import axios from "axios";
import qs from "qs";
import enums from "../enums";
import trackingUtils from "../trackingUtils";
import properties from "../properties";
import sessionUtils from "../sessionUtils";
import utils from "../utils";
import userUtils from "../userUtils";
import interceptorsSetup from "./interceptor";

let currentRouter: any = null;
let currentEnv: any = null;
let currentAppFolder: any = null;
let currentConfigPath: any = null;
let currentStore: any = null;
//[GCDM-237883] Show region as regions in addressbook: Implementation 
const regionCodes = {};


export const prepareUrl = (url, gcid?) => {
  let preparedUrl = url;
  preparedUrl = preparedUrl.replace("${BC_ID}", currentStore.getters.configure("_bc_id"));
  if(gcid) {
    preparedUrl = preparedUrl.replace("${GC_ID}", gcid);
  }

  const env = currentStore.getters.configure("env");
  if (env) {
    Object.keys(env).forEach(keyParam => {
      const normalizedKey = "${APP_".concat(keyParam.toUpperCase()).concat("}");
      preparedUrl = preparedUrl.replace(normalizedKey, env[keyParam]);
    });

    preparedUrl = preparedUrl.replace('${APP_BASE_URL}', env.base_legacy_url);
  }
  return  preparedUrl;
};

const init = (router,env,appFolder,configPath,store)=>{
  interceptorsSetup();

  currentRouter = router;
  currentEnv = env;
  currentAppFolder = appFolder;
  currentConfigPath = configPath;
  currentStore= store;
}

const areEpaasAndTracyEnabled = function(){
  const areEpaasAndTracyEnabledGlobal = currentStore.getters.configure("enable_epaas_&_tracy_tracking_global");
  const areEpaasAndTracyEnabledClient = currentStore.getters.configure("enable_epaas_&_tracy_tracking");
  if (areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient !== undefined) {
       return areEpaasAndTracyEnabledClient;
  }
  return areEpaasAndTracyEnabledGlobal;
}

export default {
  init,
  prepareUrl,
  signUp: function (body: any, userCode: any = null, hcaptchaToken?): Promise<any> {
    let registrationUrl = prepareUrl(
      currentStore.getters.configure("api_url_registration")
    );
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }

    if(currentEnv !== "pmt" && hcaptchaToken){
      config.headers['hCaptchaToken']=hcaptchaToken;
    }

    if(userCode){
      registrationUrl=registrationUrl+"?user_code="+userCode;
    }

    return axios
      .post(registrationUrl, body, config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, registrationUrl, 'signUp', false, false));
  },

  createPasslessAccountFromPreRegistration: function (body: any, token, tnrParams: {brand: string, country: string, language: string}): Promise<any> {
    const registrationUrl = prepareUrl(
      currentStore.getters.configure("api_url_passless_preregistration")
    );
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }

    config = {
      ...config,
      params: {
        ...tnrParams
      }
    }

    return axios
      .post(registrationUrl+"/"+token, body, config)
      .then((res) => {
        //do something
        return res.data;
      })
      .catch((err) => this.handleErrors(err, registrationUrl, 'createPasslessAccountFromPreRegistration', false, false));
  },

  completePasslessPreregistration: function (body: any, hCaptchaToken): Promise<any> {
    const registrationUrl = prepareUrl(
      currentStore.getters.configure("api_url_complete_passless_preregistration")
    );
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }

    if (currentEnv !== "pmt" && hCaptchaToken) {
      if (!config) {
        config = {
          headers: {}
        }
      }

      config.headers['hCaptchaToken'] = hCaptchaToken;
    }

    return axios
      .post(registrationUrl, body, config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, registrationUrl, 'completePasslessPreregistration', false, false));
  },


  getToken(code, client, codeVerifier, redirectPage= 'profile'): Promise<any> {
    const url = prepareUrl(currentStore.getters.configure("api_url_get_token"));
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    };
    let redirectUri = `${currentAppFolder}${redirectPage}/`;

    const body={
      grant_type:'authorization_code',
      redirect_uri:redirectUri,
      code:code,
      client_id:client,
      code_verifier:codeVerifier
    };
    return axios
      .post(url,qs.stringify(body), config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, url, 'getToken', false, false));
  },

  refreshToken(refreshToken, client, codeVerifier): Promise<any> {
    const url = prepareUrl(currentStore.getters.configure("api_url_get_token"));
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    };

    const body={
      grant_type:'refresh_token',
      refresh_token:refreshToken,
      client_id:client,
      code_verifier:codeVerifier
    };
    return axios
      .post(url,qs.stringify(body), config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, url, 'refreshToken', false, false));
  },

  tokenLogout: function (startuptoken?): Promise<any> {
    currentStore.dispatch("logout");
    const logoutUrl = prepareUrl(currentStore.getters.configure("api_url_logout_revoke"));

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    };
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const body = { token: token };
    return axios
      .post(logoutUrl, qs.stringify(body), config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, logoutUrl, 'tokenLogout', false, false));
  },

  sessionLogout: function (clientId): Promise<any> {

    currentStore.dispatch("logout");
    const logoutUrl = prepareUrl(currentStore.getters.configure("api_url_logout_session_revoke"));

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    };
    const body = { client_id: clientId };
    return axios
      .post(logoutUrl, qs.stringify(body), config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => {
        //do something else

        //TODO TOREMOVE
        document.cookie = 'GCDMSSO=LOGGEDOFF; path=/; secure; domain=' + '.' + location.host+ '; expires=Thu, 01 Jan 1970 00:00:00 GMT';

        return this.handleErrors(err, logoutUrl, 'sessionLogout', false, false);

      });
  },

  tokenInfo: function(token): Promise<any>{
    const url = prepareUrl(currentStore.getters.configure("api_url_token_info"));

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    };
    const body={
      access_token: token
    };

    return axios.post(url, qs.stringify(body), config).then((res) => {
      return res;
    })
    .catch((err) => {
       return this.handleErrors(err, url, 'tokenInfo', false, false);
    });
  },

  resendEmail: function (mail: any): Promise<any> {
    const resendEmailUrl = prepareUrl(
      currentStore.getters.configure("api_url_resendmail")
    );
    const body = { loginId: mail };
    let config = {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config.headers["X-c2b-Api-Key"]= clientId
    }
    return axios
      .post(resendEmailUrl, qs.stringify(body), config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, resendEmailUrl, 'resendEmail', false, false));
  },




  signIn: function (body: any, permanentLogin, hcaptchaToken): Promise<any> {
    const config = {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    };
    if(currentEnv !== "pmt" && hcaptchaToken){
      config.headers['hCaptchaToken']=hcaptchaToken;
    }
    let loginUrl = prepareUrl(currentStore.getters.configure("api_url_login"));
    if(areEpaasAndTracyEnabled() && window['epaas'] && window['epaas'].api.isInitialized()){
      loginUrl = trackingUtils.prepareEpaasParameters(loginUrl);
    }
    if (permanentLogin) {
      if(loginUrl.includes('?')){
        loginUrl = loginUrl+'&permanent='+permanentLogin;
      }else{
        loginUrl = loginUrl+'?permanent='+permanentLogin;
      }
    }
    return axios
      .post(loginUrl, qs.stringify(body), config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, loginUrl, 'signIn', false, false));
  },

  registrationPolling: function (email: string) {
    const registrationPollingUrl = prepareUrl(currentStore.getters.configure("api_url_registration_polling"));
    let url = registrationPollingUrl.replace("${loginId}", encodeURIComponent(email));

    let config;
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }

    return axios.get(url, config)
      .then(res => {
        return res;
      })
      .catch(err => this.handleErrors(err, url, 'registrationPolling', false, false));
  },

  activateUser: function (token: string, userCode, tnrParams: {brand: string, country: string, language: string}) {
    const activationUrl = prepareUrl(currentStore.getters.configure("api_url_account_activation"));
    let url = activationUrl.replace("${token}", token);
    if(userCode) url = url+"?user_code="+userCode;
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }
    
    config = {
      ...config,
      params: {
        ...tnrParams
      }
    }

    return axios
      .post(url, {}, config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, url, 'activateUser', false, false));
  },

  getVis: function (vin: string, lang: string, country: string) {
    const config = {
      withCredentials: true,
      headers: {
        "KeyId": currentStore.getters.configure("key_for_get_vis_api"),
      },
    };
    const visUrl = prepareUrl(currentStore.getters.configure("api_url_get_vis"));
    const url = visUrl.replace("${vin}", vin).replace("${lang}", lang).replace("${country}", country);
    return axios
      .get(url, config)
      .then((res) => {
        //do something
        return res.data;
      })
      .catch((err) => this.handleErrors(err, url, 'getVis', false, false));
  },

  getPolicyDocument: function (policyDocumentName: string) {
    let url = prepareUrl(currentStore.getters.configure("api_url_terms_condition"));
    url = url.replace("${policy_document_name}", policyDocumentName);
    url = url.replace(
      "${country}",
      currentStore.getters.configure("_terms_condition_fixed_country") ||
        currentStore.state.configurationParams.country
    );
    let config = {
      headers: {
        keyId: currentStore.getters.configure("key_for_terms_condition_id"),
        "Content-Type": "application/json",
      },
    };
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config.headers["X-c2b-Api-Key"]= clientId
    }

    return axios
      .get(url, config)
      .then((res) => {
        return res.data;
      })
      .catch((err) => this.handleErrors(err, url, 'getPolicyDocument', false, false));
  },

  getConfig: function (path) {
    const bypassCacheParam = "?t=" + new Date().getTime();
    const configPath =
      currentConfigPath + path + bypassCacheParam;
    return axios
      .get(configPath)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  sendResetMail(loginId: string, hcaptchaToken?): Promise<any> {
    const url = prepareUrl(currentStore.getters.configure("api_url_reset_send_mail"));
    let config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    };
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config.headers['X-c2b-Api-Key'] = clientId;
    }

    if(currentEnv !== "pmt" && hcaptchaToken){
      config.headers['hCaptchaToken']=hcaptchaToken;
    }

    return axios
      .post(url,qs.stringify({loginId: loginId}), config)
      .then((res) => {
        //do something
        return res;
      })
      .catch((err) => this.handleErrors(err, url, 'sendResetMail', false, false));
  },

  resetChangePassword(token: string, newPassowrd: string, tnrParams: {brand: string, country: string, language: string}): Promise<any> {
    let url = prepareUrl(currentStore.getters.configure("api_url_reset_change_password"));
    url = url.replace("${token}", token);
    let config: any = {
      headers: {
        "Content-Type": "text/plain",
      },
    };
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config.headers["X-c2b-Api-Key"]= clientId
    }

    config = {
      ...config,
      params: {
        ...tnrParams
      }
    }

    return axios
      .post(url, newPassowrd, config)
      .then((res) => {
        return res;
      })
      .catch((err) => this.handleErrors(err, url, 'resetChangePassword', false, false));
  },

  saveConsents(consents, startuptoken?): Promise<any> {
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const gcid = currentStore.getters.getUser?.gcid;

    const accessToken = `Bearer ${token}`;
      let url = prepareUrl(currentStore.getters.configure("api_url_consents"), gcid);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
        withCredentials: true,
      };
      return axios
        .post(url, consents, config)
        .then((res) => {
          return res;
        })
        .catch((err) => this.handleErrors(err, url, 'saveConsents', true, startuptoken, consents));

  },

  deleteAccount(startuptoken?): Promise<any> {
    if (currentEnv !== "development" ) {
      const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const url = prepareUrl(
      currentStore.getters.configure("api_url_profile_get_user_info")
    );
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      withCredentials: true,
    };
    return axios
      .delete(url, config)
      .then((res) => {
        return res;
      }).catch((err) =>  this.handleErrors(err, url, 'deleteAccount', true, startuptoken));
    }
    else {
      return Promise.resolve({
        data: {
          accountNotDeletedReason: "mocked api call failure"
        }
      });
    }
  },

  async getUserInfo(startuptoken?): Promise<any> {
    if (currentEnv !== "development" ) {
    
      let getBusinessPartnersPromise = this.getBusinessPartners(startuptoken);
      let getUserAccountsPromise = this.getUserAccounts(startuptoken);

      let user;

      const res1 = await Promise.all([getBusinessPartnersPromise, getUserAccountsPromise]);
      const businessPartner = res1[0].data[0];
      const gcid = businessPartner.gcid; 
      const ucid = businessPartner.ucid;

      const userAccount = res1[1].data[0];

      const res2 = await this.getConsents(gcid, startuptoken);
      const contactPolicyConsents = res2.data;

      user = {
        businessPartner,
        userAccount,
        contactPolicyConsents,
        gcid,
        ucid
      };

      user = this.sortPhoneNumbers(user);
      user = this.sortAddresses(user);

      currentStore.dispatch("setupUser", user);

      return new Promise<any>((resolve, reject) => {
        return user?.gcid ? resolve(user) : reject()
      });


      /*return axios
        .get(url, config)
        .then((res) => {
          //do something
          let user = res.data[0];

          user = this.sortPhoneNumbers(user);
          user = this.sortAddresses(user);

          currentStore.dispatch("setupUser", user);
          return res;
        })
        .catch((err) =>  this.handleErrors(err, url, 'getUserInfo', true, startuptoken));*/
    } else {
      /* const data =
        {
          "businessPartner": {
            "gcid": "beb4275b-e0d5-4e1f-aad9-c8fe572b1071",
            "ucid": "S002232724",
            "partnerType": "PAR_TYP_VIP",
            "partnerCategory": "PERSON",
            "surname": "Caldarelli",
            "givenName": "Sirian",
            "middleName": "Ilaria",
            "additionalFamilyName": "Hyde",
            "nickname": "P",
            "salutation": "SAL_MS",
            "title": "TIT_PROF",
            "additionalAcademicTitleCode": "TIT_DR",
            "nameSupplementCode": "NAM_SUP_JHR",
            "namePrefixCode": "VON",
            "additionalNamePrefixCode": "NP",
            "birthday": "2021-05-17",
            "birthdayDelete": false,
            "birthAddress": {
              "careOfName": "Doorman",
              "street": "St.Martin",
              "strSuppl1": "Straße",
              "strSuppl2": "71",
              "strSuppl3": "north",
              "location": "city",
              "streetType": "public",
              "houseNumber": "81",
              "additionalHouseID": "A1",
              "buildingID": "Central",
              "floorID": "7",
              "roomID": "24",
              "postalCode": "80331",
              "postOfficeBox": "RosenStr.8",
              "city": "Munich",
              "districtName": "urban",
              "country": "AD",
              "regionCode": "49",
              "receiverLastName": "Schmidt",
              "receiverFirstName": "Robert",
              "companyName": "BMW",
              "companyDepartment": "IT",
              "addressStatus": "PRIVATE",
              "preferred": true,
              "shipment": true,
              "invoice": true
            },
            "gender": "FEMALE",
            "contactChannelAreaSpecs": [
              {
                "contactChannel": "CON_CHA_TYP_EMAIL",
                "usageArea": "MARKETING"
              }
            ],
            "correspondLanguageISO": "EN",
            "occupationCode": "OCC_FREELANCER_SELF_EMPLOYED",
            "nationalityISO": "GB",
            "customerStatus": "ACTIVE",
            "nameSuffixGeneration": "JR",
            "homeMarket": "AQ",
            "profile": {
              "plannedPurchaseScheduled": "YES",
              "incomeCurrency": "EUR",
              "ageRangeChildren": "AGE_RAN_CHI_MIDDLE_OLDER",
              "eReadiness": true,
              "preferredSalesChannel": "CHA_TYP_ONLINE",
              "communicationTypePreferred": "MOB",
              "lifestyle": "LIF_MODERN",
              "sustainability": "SUS_UNKNOWN",
              "outstanding": "OUT_YES",
              "perspectives": "perspectives",
              "position": "employee",
              "highestDegree": "Master",
              "jobTitle": "Software developer",
              "branch": "IND_SPORT",
              "maritalStatus": "MARRIED",
              "interests": {
                "interests": [
                  {
                    "id": "INT_TYP_SURFING"
                  }
                ]
              },
              "vehicleInterests": {
                "vehicleInterests": [
                  {
                    "brand": "BMW",
                    "productId": "AB234"
                  }
                ]
              },
              "subscriptions": {
                "subscriptions": [
                  {
                    "startDate": "2021-05-17",
                    "startDateDelete": false,
                    "endDate": "2021-05-17",
                    "endDateDelete": false,
                    "treatmentId": "123",
                    "subscriptionType": "SUB_NEWSLETTER_UNSUBSCRIBE",
                    "subscriptionGUID": "8622ae60-1738-47b9-83e5-f46290039f9c"
                  }
                ]
              }
            },
            "addresses": {
              "addresses": [
                {
                  "addressChecked": true,
                  "addressGUID": "0fc61b1d-e9ee-4132-826d-bd10050113a7",
                  "careOfName": "Doorman",
                  "street": "St.Martin",
                  "strSuppl1": "Straße",
                  "strSuppl2": "71",
                  "strSuppl3": "north",
                  "location": "city",
                  "streetType": "public",
                  "houseNumber": "81",
                  "additionalHouseID": "A1",
                  "buildingID": "Central",
                  "floorID": "7",
                  "roomID": "24",
                  "postalCode": "80331",
                  "postOfficeBox": "RosenStr.8",
                  "city": "Munich",
                  "districtName": "urban",
                  "country": "AT",
                  "regionCode": "49",
                  "receiverLastName": "Schmidt",
                  "receiverFirstName": "Robert",
                  "companyName": "BMW",
                  "companyDepartment": "IT",
                  "addressStatus": "PRIVATE",
                  "preferred": true,
                  "shipment": true,
                  "invoice": true,
                  "updatedAt": "2023-02-27T07:36:32.833Z"
                }
              ]
            },
            "communications": {
              "communicationPhones": [
                {
                  "consGUID": "a84ccdd7-3571-4dc2-87c3-229a73b16a0b",
                  "communicationType": "FAX",
                  "communicationStatus": "PRIVATE",
                  "preferred": true,
                  "value": "+49 170555555",
                  "updatedAt": "2023-02-27T07:36:32.833Z"
                }
              ],
              "communicationEMails": [
                {
                  "consGUID": "7e6c766f-4dd4-4997-aa1b-363e795ec7a4",
                  "communicationStatus": "PRIVATE",
                  "preferred": true,
                  "value": "testemail@email.com",
                  "communicationType": "EMAIL",
                  "updatedAt": "2023-02-27T07:36:32.833Z"
                }
              ],
              "availability": "BMW ConnectedDrive"
            },
            "dealers": {
              "dealers": [
                {
                  "isMainDealer": true,
                  "distributionPartnerId": "Nn760",
                  "outletId": "2E",
                  "dealerName": "j9ASnVg",
                  "brand": "BMW",
                  "dealerBusinessPartnerRelations": [
                    {
                      "dealerBusinessPartnerRelationType": "DEA_BUP_PREF",
                      "usageArea": "MARKETING"
                    }
                  ],
                  "dealerGUID": "5060698a-b289-43ec-8241-a7d49fa2cb3c",
                  "updatedAt": "2023-02-27T07:36:32.833Z"
                }
              ]
            },
            "lastUpdated": {
              "at": "2023-02-27T07:36:32.833Z",
              "bySource": "CUSTOMER"
            },
            "claims": [
              {
                "id": "DE",
                "timestamp": "2023-02-27T07:36:32.909Z"
              }
            ]
          },
          "gcid": "beb4275b-e0d5-4e1f-aad9-c8fe572b1071",
          "ucid": "S002232724"
        }  */
      /* const data = {
          "businessPartner": {
            "gcid": "554dd692-9edb-48b0-9d8c-020b91486efd",
            "ucid": "S002232722",
            "partnerType": "PAR_TYP_VIP",
            "partnerCategory": "PERSON",
            "surname": "Caldarelli",
            "givenName": "Sirian",
            "middleName": "Ilaria",
            "additionalFamilyName": "Hyde",
            "nickname": "P",
            "salutation": "SAL_MS",
            "title": "TIT_PROF",
            "additionalAcademicTitleCode": "TIT_DR",
            "nameSupplementCode": "NAM_SUP_JHR",
            "namePrefixCode": "VON",
            "additionalNamePrefixCode": "NP",
            "birthday": "2021-05-17",
            "birthdayDelete": false,
            "birthAddress": {
              "careOfName": "Doorman",
              "street": "St.Martin",
              "strSuppl1": "Straße",
              "strSuppl2": "71",
              "strSuppl3": "north",
              "location": "city",
              "streetType": "public",
              "houseNumber": "81",
              "additionalHouseID": "A1",
              "buildingID": "Central",
              "floorID": "7",
              "roomID": "24",
              "postalCode": "80331",
              "postOfficeBox": "RosenStr.8",
              "city": "Munich",
              "districtName": "urban",
              "country": "AD",
              "regionCode": "49",
              "receiverLastName": "Schmidt",
              "receiverFirstName": "Robert",
              "companyName": "BMW",
              "companyDepartment": "IT",
              "addressStatus": "PRIVATE",
              "preferred": true,
              "shipment": true,
              "invoice": true
            },
            "gender": "FEMALE",
            "contactChannelAreaSpecs": [
              {
                "contactChannel": "CON_CHA_TYP_EMAIL",
                "usageArea": "MARKETING"
              }
            ],
            "correspondLanguageISO": "EN",
            "occupationCode": "OCC_FREELANCER_SELF_EMPLOYED",
            "nationalityISO": "GB",
            "customerStatus": "ACTIVE",
            "nameSuffixGeneration": "JR",
            "homeMarket": "AQ",
            "profile": {
              "plannedPurchaseScheduled": "YES",
              "incomeCurrency": "EUR",
              "ageRangeChildren": "AGE_RAN_CHI_MIDDLE_OLDER",
              "eReadiness": true,
              "preferredSalesChannel": "CHA_TYP_ONLINE",
              "communicationTypePreferred": "MOB",
              "lifestyle": "LIF_MODERN",
              "sustainability": "SUS_UNKNOWN",
              "outstanding": "OUT_YES",
              "perspectives": "perspectives",
              "position": "employee",
              "highestDegree": "Master",
              "jobTitle": "Software developer",
              "branch": "IND_SPORT",
              "maritalStatus": "MARRIED",
              "interests": {
                "interests": [
                  {
                    "id": "INT_TYP_SURFING"
                  }
                ]
              },
              "vehicleInterests": {
                "vehicleInterests": [
                  {
                    "brand": "BMW",
                    "productId": "AB234"
                  }
                ]
              },
              "subscriptions": {
                "subscriptions": [
                  {
                    "startDate": "2021-05-17",
                    "startDateDelete": false,
                    "endDate": "2021-05-17",
                    "endDateDelete": false,
                    "treatmentId": "123",
                    "subscriptionType": "SUB_NEWSLETTER_UNSUBSCRIBE",
                    "subscriptionGUID": "b1fd7c7b-446a-4bfe-a0ab-078e9ca353d7"
                  }
                ]
              }
            },
            "addresses": {
              "addresses": [
                {
                  "addressChecked": true,
                  "addressGUID": "8def8ca5-dc6f-4c55-8353-d4102687885c",
                  "careOfName": "Doorman",
                  "street": "St.Martin",
                  "strSuppl1": "Straße",
                  "strSuppl2": "71",
                  "strSuppl3": "north",
                  "location": "city",
                  "streetType": "public",
                  "houseNumber": "81",
                  "additionalHouseID": "A1",
                  "buildingID": "Central",
                  "floorID": "7",
                  "roomID": "24",
                  "postalCode": "80331",
                  "postOfficeBox": "RosenStr.8",
                  "city": "Munich",
                  "districtName": "urban",
                  "country": "AT",
                  "regionCode": "49",
                  "receiverLastName": "Schmidt",
                  "receiverFirstName": "Robert",
                  "companyName": "BMW",
                  "companyDepartment": "IT",
                  "addressStatus": "PRIVATE",
                  "preferred": true,
                  "shipment": true,
                  "invoice": true,
                  "updatedAt": "2023-02-27T07:36:28.592Z"
                }
              ]
            },
            "communications": {
              "communicationPhones": [
                {
                  "consGUID": "240f1e53-163e-4c7e-ac0c-146c9a95d593",
                  "communicationType": "FAX",
                  "communicationStatus": "PRIVATE",
                  "preferred": true,
                  "value": "+49 170555555",
                  "updatedAt": "2023-02-27T07:36:28.592Z"
                }
              ],
              "communicationEMails": [
                {
                  "consGUID": "c4bb2d86-3009-47c7-abcf-fc73b3521e00",
                  "communicationStatus": "PRIVATE",
                  "preferred": true,
                  "value": "testemail@email.com",
                  "communicationType": "EMAIL",
                  "updatedAt": "2023-02-27T07:36:28.592Z"
                }
              ],
              "availability": "BMW ConnectedDrive"
            },
            "dealers": {
              "dealers": [
                {
                  "isMainDealer": true,
                  "distributionPartnerId": "Nn760",
                  "outletId": "2E",
                  "dealerName": "j9ASnVg",
                  "brand": "BMW",
                  "dealerBusinessPartnerRelations": [
                    {
                      "dealerBusinessPartnerRelationType": "DEA_BUP_PREF",
                      "usageArea": "MARKETING"
                    }
                  ],
                  "dealerGUID": "553a006d-20c6-41ee-b615-6b869b2d8f09",
                  "updatedAt": "2023-02-27T07:36:28.592Z"
                }
              ]
            },
            "lastUpdated": {
              "at": "2023-02-27T07:36:28.592Z",
              "bySource": "CUSTOMER"
            },
            "claims": [
              {
                "id": "DE",
                "timestamp": "2023-02-27T07:36:28.663Z"
              }
            ]
          },
          "gcid": "554dd692-9edb-48b0-9d8c-020b91486efd",
          "ucid": "S002232722"
        } */
      const data =  {
        "businessPartner" : {
          "gcid" : "ee65d751-1396-4c4b-94c4-81e901b0be8a",
          "ucid" : "C180534661",
          "partnerType" : "PAR_TYP_PRIVATE",
          "partnerCategory" : "PERSON",
          "surname" : "surname",
          "givenName" : "mary-thanks",
          "additionalFamilyName" : "umyjtfkna",
          "salutation" : "SAL_MR",
          "title" : "TIT_PROF",
          "birthdayDelete" : false,
          "gender" : "MALE",
          "correspondLanguageISO" : "EN",
          "customerStatus" : "ACTIVE",
          "birthAddress":{
            "city":'rome'
          },
          "dealers": {
            "dealers": [
              /* {
                "isMainDealer": false,
                "dealerName": "Dealer Name",
                "distributionPartnerId": "30778",
                "outletId": "1",
                "brand": "BMW_MOTORRAD"
              },
              {
                "isMainDealer": false,
                "dealerName": "Gottstein GmbH Automobile + Motorräder",
                "distributionPartnerId": "29925",
                "outletId": "1",
                "brand": "MINI",
                "isPreferredSalesDealer": true,
                "isPreferredServiceDealer": true
              },
              {
                "isMainDealer": false,
                "dealerName": "Autohaus Josef Mayer GmbH",
                "distributionPartnerId": "30976",
                "outletId": "1",
                "brand": "MINI",
                "isPreferredSalesDealer": true,
                "isPreferredServiceDealer": true
              },
              {
                "isMainDealer": false,
                "dealerName": "Autohaus Kühnert GmbH & Co. KG",
                "distributionPartnerId": "04553",
                "outletId": "8",
                "brand": "BMW"
              },
              {
                "isMainDealer": false,
                "dealerName": "Autohaus Backhaus Inh. Christoph Backhaus e.K.",
                "distributionPartnerId": "01575",
                "outletId": "1",
                "brand": "BMW"
              } */
            ]
          },
          "homeMarket" : "ES",
          "initialsName": "DE",
          "alternativeCustomerIds" : {
            "alternativeCustomerIds" : [ {
              "id" : "D68EFB8E-AD9C-4751-9923-344F2C11B6E5",
              "type" : "ALT_CUS_SE"
            } ]
          },
          "addresses" : {
            "addresses" : [
              {
                "addressChecked" : true,
                "addressGUID" : "fafc6c2b-f151-427f-b16f-ea2cb8e9dad2",
                "street" : "Test",
                "strSuppl1" : "Test",
                "postalCode" : "Test",
                "city" : "Test",
                "country" : "JP",
                "addressStatus" : "PRIVATE",
                "preferred" : true,
              },
              {
                "addressGUID": "2bcc299c-ad1d-4257-ae4c-051d6a36cbea",
                "addressStatus": "BUSINESS",
                "city": "Siemianowice Śląskie",
                "country": "PL",
                "houseNumber": "2",
                "postalCode": "41-100",
                "regionCode": "Śląskie",
                "street": "ul. Czeladzka",
                "updatedAt": "2022-12-22T09:54:21.384Z",
                "preferred": false,
                "postOfficeBox":"blabla"
              },
              {
                "addressGUID": "2bcc299c-ad1d-4257-ae4c-051d6a36cbea",
                "addressStatus": "BUSINESS",
                "city": "Siemianowice Śląskie",
                "country": "PL",
                "houseNumber": "3",
                "postalCode": "41-100",
                "regionCode": "Śląskie",
                "street": "ul. Czeladzka",
                "updatedAt": "2022-12-22T09:54:21.384Z",
                "preferred": true
              },
              {
                "addressGUID": "2bcc299c-ad1d-4257-ae4c-051d6a36cbea",
                "addressStatus": "PRIVATE",
                "city": "Siemianowice Śląskie",
                "country": "PL",
                "houseNumber": "4",
                "postalCode": "41-100",
                "regionCode": "Śląskie",
                "street": "ul. Czeladzka",
                "updatedAt": "2022-12-22T09:54:21.384Z",
                "preferred": false
              },
            ]
          },
          "communications" : {
            "communicationPhones" : [
              {
                "consGUID" : "eb7c0920-f52a-4410-8940-a17d0c9b0b2a",
                "communicationType" : "MOB",
                "communicationStatus" : "PRIVATE",
                "preferred" : false,
                "value" : "+39 340 700 7070"
              },
              {
                "consGUID" : "eb7c0920-f52a-4410-8940-a17d0c9b0b2b",
                "communicationType" : "MOB",
                "communicationStatus" : "PRIVATE",
                "updatedAt" : "2023-01-10T12:13:17.970Z",
                "preferred" : true,
                "value" : "+39 340 700 7071"
              },
              {
                "consGUID" : "eb7c0920-f52a-4410-8940-a17d0c9b0b2c",
                "communicationType" : "MOB",
                "communicationStatus" : "BUSINESS",
                "preferred" : false,
                "value" : "+39 340 700 7072"
              },
              {
                "consGUID" : "eb7c0920-f52a-4410-8940-a17d0c9b0b2d",
                "communicationType" : "TEL",
                "communicationStatus" : "PRIVATE",
                "preferred" : false,
                "value" : "+39 340 700 7073"
              },
              {
                "consGUID" : "eb7c0920-f52a-4410-8940-a17d0c9b0b2e",
                "communicationType" : "TEL",
                "communicationStatus" : "BUSINESS",
                "preferred" : false,
                "value" : "+39 340 700 7074"
              }
            ],
            "communicationEMails" : [
              {
                "consGUID" : "b95dab5e-3a8b-4d4b-bf29-f4c3234f80ff",
                "communicationStatus" : "PRIVATE",
                "preferred" : true,
                "value" : "testpasskey3@mailinator.com",
                "communicationType" : "EMAIL"
              },
              {
                "consGUID" : "b95dab5e-3a8b-4d4b-bf29-f4c3234f80ff",
                "communicationStatus" : "PRIVATE",
                "preferred" : false,
                "value" : "testaccount@mailinator.com",
                "communicationType" : "EMAIL"
              }  ,
              {
                "consGUID" : "b95dab5e-3a8b-4d4b-bf29-f4c3234f80ff",
                "communicationStatus" : "BUSINESS",
                "preferred" : false,
                "value" : "testBusinss@mailinator.com",
                "communicationType" : "EMAIL"
              }  ,
              {
                "consGUID" : "b95dab5e-3a8b-4d4b-bf29-f4c3234f80ff",
                "communicationStatus" : "BUSINESS",
                "preferred" : false,
                "value" : "testBusinessDue@mailinator.com",
                "communicationType" : "EMAIL"
              }
            ]
          },
          "customExtension" : {
            "parameters" : [ {
              "key" : "alternateFirstName",
              "value" : "kana1"
            } ]
          },
          "lastUpdated" : {
            "at" : "2022-08-17T15:58:41.290Z",
            "bySource" : "CUSTOMER"
          },
          "claims" : [ {
            "id" : "RU",
            "timestamp" : "2022-03-30T12:11:12.069Z"
          }, {
            "id" : "JP",
            "timestamp" : "2022-03-22T13:38:24.978Z"
          }, {
            "id" : "DE",
            "timestamp" : "2022-03-28T10:30:30.732Z"
          }, {
            "id" : "GB",
            "timestamp" : "2022-04-05T08:05:00.368Z"
          }, {
            "id" : "KR",
            "timestamp" : "2022-04-14T08:59:35.762Z"
          }, {
            "id" : "IT",
            "timestamp" : "2022-04-20T15:36:31.918Z"
          }, {
            "id" : "IN",
            "timestamp" : "2022-04-28T14:55:08.565Z"
          }, {
            "id" : "TH",
            "timestamp" : "2022-06-03T10:38:47.297Z"
          }, {
            "id" : "RO",
            "timestamp" : "2022-06-06T08:27:20.711Z"
          }, {
            "id" : "CH",
            "timestamp" : "2022-08-01T17:37:04.494Z"
          } ]
        },
        "userAccount" : {
          "mail" : "testpasskey3@mailinator.com",
          "notificationLevel" : "NEW_DEVICE",
          "authenticationLevel" : "ONE_FACTOR",
          "pwPolicyConform" : true,
          "gcid" : "ee65d751-1396-4c4b-94c4-81e901b0be8a",
          "secretKnowledgeActivated" : false,
          "status" : "ACTIVATED",
          "linkedAccounts": [
            {
              "type": "CONNECTED_MAPPING"
            }
          ],
        },
        "contactPolicyConsents" : [ {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_RIDE_TAC",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 6,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "Connected Ride",
          "language" : "en",
          "consentDate" : "2023-01-02T13:45:27.931Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-01-02T13:45:27.931Z",
          "consentGroupId" : "2fa832cc-cade-4da5-a9cd-389330d85f99"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_TAGGING_TEST",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-13T11:15:58.998Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-13T11:15:58.998Z",
          "consentGroupId" : "21446ddd-a6a9-4be3-92ff-f384e2cbbeaf"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_HTML",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "test_touchpoint_id_primary_text",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-02-03T11:05:24.553Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-02-03T11:05:24.553Z",
          "consentGroupId" : "f775ed70-7738-44d2-b51f-703b84954b15"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "GB",
          "majorVersion" : 4,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "incar_vehicle",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-02-14T13:46:43.445Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3022-02-14T13:46:43.445Z",
          "consentGroupId" : "a5bfd8f6-f30d-4808-af45-ef966039c663"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_TAGGING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-02-13T11:12:45.717Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-02-13T11:12:45.717Z",
          "consentGroupId" : "6e4a112a-63a6-4e46-a262-33f69e68b596"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_TAGGING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-12-22T09:51:34.716Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-12-22T09:51:34.716Z",
          "consentGroupId" : "92831edf-f41d-4212-a680-b44d0eaacba1"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_PD",
          "country" : "KR",
          "majorVersion" : 4,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "DATA_PRIVACY",
          "touchpointId" : "taf",
          "language" : "ko",
          "brand" : "BMW",
          "consentDate" : "2023-02-15T16:06:24.541Z",
          "legalEntityId" : "BMW_KOREA_CO_LTD_",
          "expirationDate" : "3022-02-15T16:06:24.541Z",
          "consentGroupId" : "fce2a5b3-dd9b-47e9-b1b6-c98161d24529"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_PLD",
          "country" : "KR",
          "majorVersion" : 4,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "DATA_PRIVACY",
          "touchpointId" : "taf",
          "language" : "ko",
          "brand" : "BMW",
          "consentDate" : "2023-02-15T16:06:24.541Z",
          "legalEntityId" : "BMW_KOREA_CO_LTD_",
          "expirationDate" : "3022-02-15T16:06:24.541Z",
          "consentGroupId" : "7311069d-2cef-48c4-a913-3b6c97bf1299"
        }, {
          "consent" :  "ACCEPT",
          "consentDate" : "2023-05-10T11:09:18.826Z",
          "consentGroupId" : "df7b214a-4227-4cc3-8612-1daf1bf5c1b8",
          "country" : "TW",
          "expirationDate" : "3022-05-10T11:09:18.826Z",
          "language" : "zh",
          "legalEntityId" : "PAN_GERMAN_MOTORS_LTD_",
          "majorVersion" : 4,
          "minorVersion" : 0,
          "policyId" : "MINI_CONNECTED_TAC",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "incar_vehicle",
          "usageId" : "CONNECTED_DRIVE"
        }, {
          "consent" :  "ACCEPT",
          "consentDate" : "2023-05-10T11:09:18.826Z",
          "consentGroupId" : "df7b214a-4227-4cc3-8612-1daf1bf5c1b8",
          "country" : "TW",
          "expirationDate" : "3022-05-10T11:09:18.826Z",
          "language" : "zh",
          "legalEntityId" : "PAN_GERMAN_MOTORS_LTD_",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "policyId" : "MINI_APP_TAC",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "incar_vehicle",
          "usageId" : "CONNECTED_DRIVE"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "TW",
          "majorVersion" : 4,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "bmwwebcom",
          "language" : "zh",
          "brand" : "BMW",
          "consentDate" : "2022-12-01T16:21:34.713Z",
          "legalEntityId" : "PAN_GERMAN_MOTORS_LTD_",
          "expirationDate" : "3021-12-01T16:21:34.713Z",
          "consentGroupId" : "8efd993c-f93f-436c-ae4d-ad6d7273b83b"
        } ],
        /* "contactPolicyConsents": [
          {
              "consent": "ACCEPT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "APP",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2023-12-07T15:03:10.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:03:05.225Z",
              "consentGroupId": "fc135bff-983b-4ed2-9a65-723a267432a6"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "ANALYTICS",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:03:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:03:05.225Z",
              "consentGroupId": "fc135bff-983b-4ed2-9a65-723a267432a6"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "MAIL",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:03:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:03:05.225Z",
              "consentGroupId": "fc135bff-983b-4ed2-9a65-723a267432a6"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "PHONE_MESSENGER_SERVICES",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-07T15:03:10.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:03:05.225Z",
              "consentGroupId": "fc135bff-983b-4ed2-9a65-723a267432a6"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "EMAIL",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:03:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:03:05.225Z",
              "consentGroupId": "fc135bff-983b-4ed2-9a65-723a267432a6"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "IN_CAR",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:02:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:02:05.225Z",
              "consentGroupId": "c39782f6-2545-43f0-9dbf-4456cac09b5c"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "ANALYTICS",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:02:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:02:05.225Z",
              "consentGroupId": "c39782f6-2545-43f0-9dbf-4456cac09b5c"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "MAIL",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:02:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:02:05.225Z",
              "consentGroupId": "c39782f6-2545-43f0-9dbf-4456cac09b5c"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "PHONE_MESSENGER_SERVICES",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:02:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:02:05.225Z",
              "consentGroupId": "c39782f6-2545-43f0-9dbf-4456cac09b5c"
          },
          {
              "consent": "REJECT",
              "policyId": "Marketing",
              "country": "AU",
              "majorVersion": 1,
              "minorVersion": 1,
              "usageId": "EMAIL",
              "purposeId": "MARKETING",
              "touchpointId": "formerUsageID",
              "language": "en",
              "brand": "BMW",
              "consentDate": "2022-12-06T15:02:05.225Z",
              "legalEntityId": "BMW_AUSTRALIA_LTD_",
              "expirationDate": "3021-12-06T15:02:05.225Z",
              "consentGroupId": "c39782f6-2545-43f0-9dbf-4456cac09b5c"
          }
        ], */
        "gcid": "ee65d751-1396-4c4b-94c4-81e901b0be8a",
        "ucid": "S001722579"
      }
        /* "contactPolicyConsents" : [
        {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "AU",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "formerUsageID",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-10-16T07:50:45.498Z",
          "legalEntityId" : "BMW_AUSTRALIA_LTD_",
          "expirationDate" : "3021-10-16T07:50:45.498Z",
          "consentGroupId" : "fa0f2bd7-8b17-4977-b2ec-477d6baa4f86"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "AU",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "formerUsageID",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-10-16T07:50:45.498Z",
          "legalEntityId" : "BMW_AUSTRALIA_LTD_",
          "expirationDate" : "3021-10-16T07:50:45.498Z",
          "consentGroupId" : "fa0f2bd7-8b17-4977-b2ec-477d6baa4f86"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "AU",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "formerUsageID",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-10-16T07:50:45.498Z",
          "legalEntityId" : "BMW_AUSTRALIA_LTD_",
          "expirationDate" : "3021-10-16T07:50:45.498Z",
          "consentGroupId" : "fa0f2bd7-8b17-4977-b2ec-477d6baa4f86"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "AU",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "formerUsageID",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-10-16T07:50:45.498Z",
          "legalEntityId" : "BMW_AUSTRALIA_LTD_",
          "expirationDate" : "3021-10-16T07:50:45.498Z",
          "consentGroupId" : "fa0f2bd7-8b17-4977-b2ec-477d6baa4f86"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "AU",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "formerUsageID",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-10-16T07:50:45.498Z",
          "legalEntityId" : "BMW_AUSTRALIA_LTD_",
          "expirationDate" : "3021-10-16T07:50:45.498Z",
          "consentGroupId" : "fa0f2bd7-8b17-4977-b2ec-477d6baa4f86"
        },
        {
          "consent" : "REJECTED",
          "policyId" : "Marketing",
          "country" : "AU",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "formerUsageID",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-10-16T07:50:45.498Z",
          "legalEntityId" : "BMW_AUSTRALIA_LTD_",
          "expirationDate" : "3021-10-16T07:50:45.498Z",
          "consentGroupId" : "fa0f2bd7-8b17-4977-b2ec-477d6baa4f86"
        },
        {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "AU",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "formerUsageID",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-10-16T07:50:45.498Z",
          "legalEntityId" : "BMW_AUSTRALIA_LTD_",
          "expirationDate" : "3021-10-16T07:50:45.498Z",
          "consentGroupId" : "fa0f2bd7-8b17-4977-b2ec-477d6baa4f86"
        } ],
        "gcid" : "f07bf67a-109a-411f-b85f-2ac44e5ca175",
        "ucid" : "C180534661"
      }   ; */
      let user = data;

      user = this.sortPhoneNumbers(user);
      user = this.sortAddresses(user);

      currentStore.dispatch("setupUser", user);
      return Promise.resolve(user);
    }
  },

  getBusinessPartners(startuptoken?) : Promise<any> {
      const token = startuptoken || window.localStorage.getItem("oneid_access_token");
      const url = prepareUrl(
        currentStore.getters.configure("api_url_profile_get_business_partners")
      );
      const accessToken = `Bearer ${token}`;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
        withCredentials: true,
      };
      return axios
        .get(url, config)
        .then((res) => {
          return res;
        })
        .catch((err) =>  this.handleErrors(err, url, 'getBusinessPartners', true, startuptoken));
  },

  getUserAccounts(startuptoken?) : Promise<any> {
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const url = prepareUrl(
      currentStore.getters.configure("api_url_profile_get_user_accounts")
    );
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      withCredentials: true,
    };
    return axios
      .get(url, config)
      .then((res) => {
        return res;
      })
      .catch((err) =>  this.handleErrors(err, url, 'getUserAccounts', true, startuptoken));
},

getConsents(gcid, startuptoken?) : Promise<any> {
  const token = startuptoken || window.localStorage.getItem("oneid_access_token");
  let url = prepareUrl(currentStore.getters.configure("api_url_consents"), gcid);
  const accessToken = `Bearer ${token}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
    withCredentials: true,
  };
  return axios
    .get(url, config)
    .then((res) => {
      return res;
    })
    .catch((err) =>  {
      if(err.response.status === enums.errorReasons.RESOURCE_NOT_FOUND && err.response.data.message === enums.errorReasons.NO_CONSENTS_FOUND) {
        return new Promise<any>((resolve) => resolve([]));
      }
      this.handleErrors(err, url, 'getConsents', true, startuptoken)
    });
},

  updateUser(startuptoken?) {
    const userData = currentStore.getters.getUser;
    const originalUserData = currentStore.getters.getOriginalUser;
    const parsedUser = userUtils.parseUserData(userData, originalUserData, currentStore.state.configurationParams.country);
    console.log(`[updateUser] - parsedUser: `, parsedUser);
    const body = parsedUser;
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      withCredentials: true,
    };
    const loginUrl = prepareUrl(
      currentStore.getters.configure("api_url_update_user_info")
    );

    if (currentEnv !== "development" ) {
    return axios
      .put(loginUrl, body, config)
      .then((res) => {
        //do something
        let user = res.data;

        user = this.sortPhoneNumbers(user);
        user = this.sortAddresses(user);

        currentStore.dispatch("setupUser", user);
        return res;
      })
      .catch((err) => this.handleErrors(err, loginUrl, 'updateUser', true, startuptoken));
    } else {
      const data =  {
        "businessPartner" : {
          "gcid" : "ee65d751-1396-4c4b-94c4-81e901b0be8a",
          "ucid" : "C180534661",
          "partnerType" : "PAR_TYP_PRIVATE",
          "partnerCategory" : "PERSON",
          "surname" : "surname",
          "givenName" : "mary-thanks",
          "additionalFamilyName" : "umyjtfkna",
          "salutation" : "SAL_MR",
          "title" : "TIT_PROF",
          "birthday" : "1990-11-19",
          "birthdayDelete" : false,
          "gender" : "MALE",
          "correspondLanguageISO" : "EN",
          "customerStatus" : "ACTIVE",
          "homeMarket" : "ES",
          "initialsName": "DE",
          "birthAddress":{
            "city":'rome'
          },
          "nationalityISO": "IT",
          "addresses" : {
            "addresses" : [
              {
                "addressChecked" : true,
                "addressGUID" : "fafc6c2b-f151-427f-b16f-ea2cb8e9dad2",
                "street" : "Main St.",
                "houseNumber": "1",
                "regionCode": "VIC",
                "postalCode" : "3000",
                "city" : "Melbourne",
                "country" : "AU",
                "addressStatus" : "PRIVATE",
                "preferred" : true
              },
              {
                "addressChecked" : true,
                "addressGUID" : "fafc6c2b-f151-427f-b16f-ea2cb8e9dad2",
                "street" : "Augusta Chiwystraat",
                "regionCode": "VLG",
                "postalCode" : "3000",
                "city" : "Leuven",
                "country" : "BE",
                "addressStatus" : "PRIVATE",
                "preferred" : true
              },
              {
                "addressChecked" : true,
                "addressGUID" : "fafc6c2b-f151-427f-b16f-ea2cb8e9dad2",
                "street" : "Test",
                "strSuppl1" : "Test",
                "postalCode" : "Test",
                "city" : "Test",
                "country" : "JP",
                "companyName" : "Test companyName",
                "addressStatus" : "BUSINESS",
                "postOfficeBox":"blabla",
                "preferred" : true
              }
            ]
          },
          "dealers": {
            "dealers": [
              {
                "isMainDealer": false,
                "dealerName": "Dealer Name",
                "distributionPartnerId": "30778",
                "outletId": "1",
                "brand": "BMW_MOTORRAD"
              },
              {
                "isMainDealer": false,
                "dealerName": "Gottstein GmbH Automobile + Motorräder",
                "distributionPartnerId": "29925",
                "outletId": "1",
                "brand": "MINI"
              },
              /* {
                "isMainDealer": false,
                "dealerName": "Autohaus Kühnert GmbH & Co. KG",
                "distributionPartnerId": "04553",
                "outletId": "8",
                "brand": "BMW"
              }, */
              {
                "isMainDealer": false,
                "dealerName": "Autohaus Backhaus Inh. Christoph Backhaus e.K.",
                "distributionPartnerId": "01575",
                "outletId": "1",
                "brand": "BMW"
              }
            ]
          },
          "communications" : {
            "communicationPhones" : [],
            "communicationEMails" : [ {
              "consGUID" : "11a5a22c-3da9-4398-b97c-9fbda446016b",
              "communicationStatus" : "PRIVATE",
              "preferred" : true,
              "value" : "testpasskey3@mailinator.com",
              "communicationType" : "EMAIL"
            }, {
              "consGUID" : "b455502f-19a9-4a72-823d-9ed7a5c2583c",
              "communicationStatus" : "BUSINESS",
              "preferred" : false,
              "value" : "notpreferdddred@mailinato.com",
              "communicationType" : "EMAIL"
            } ]
          },
          "alternativeCustomerIds" : {
            "alternativeCustomerIds" : [ {
              "id" : "D68EFB8E-AD9C-4751-9923-344F2C11B6E5",
              "type" : "ALT_CUS_SE"
            } ]
          },
          "customExtension" : {
            "parameters" : [ {
              "key" : "alternateFirstName",
              "value" : "kana1"
            } ]
          },
          "lastUpdated" : {
            "at" : "2022-08-17T15:58:41.290Z",
            "bySource" : "CUSTOMER"
          },
          "claims" : [ {
            "id" : "RU",
            "timestamp" : "2022-03-30T12:11:12.069Z"
          }, {
            "id" : "JP",
            "timestamp" : "2022-03-22T13:38:24.978Z"
          }, {
            "id" : "DE",
            "timestamp" : "2022-03-28T10:30:30.732Z"
          }, {
            "id" : "GB",
            "timestamp" : "2022-04-05T08:05:00.368Z"
          }, {
            "id" : "KR",
            "timestamp" : "2022-04-14T08:59:35.762Z"
          }, {
            "id" : "IT",
            "timestamp" : "2022-04-20T15:36:31.918Z"
          }, {
            "id" : "IN",
            "timestamp" : "2022-04-28T14:55:08.565Z"
          }, {
            "id" : "TH",
            "timestamp" : "2022-06-03T10:38:47.297Z"
          }, {
            "id" : "RO",
            "timestamp" : "2022-06-06T08:27:20.711Z"
          }, {
            "id" : "CH",
            "timestamp" : "2022-08-01T17:37:04.494Z"
          } ]
        },
        "userAccount" : {
          "mail" : "testpasskey3@mailinator.com",
          "notificationLevel" : "NEW_DEVICE",
          "authenticationLevel" : "ONE_FACTOR",
          "pwPolicyConform" : true,
          "gcid" : "ee65d751-1396-4c4b-94c4-81e901b0be8a",
          "secretKnowledgeActivated" : false,
          "status" : "ACTIVATED",
          "linkedAccounts": [
            {
              "type": "CONNECTED_MAPPING"
            }
          ],
        },
        "contactPolicyConsents" : [ {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "BE",
          "majorVersion" : 1,
          "minorVersion" : 3,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwapp",
          "language" : "nl",
          "brand" : "BMW",
          "consentDate" : "2021-06-03T14:19:43.728Z",
          "legalEntityId" : "BMW_BELGIUM_LUXEMBOURG_NV_SA_BORNEM",
          "expirationDate" : "3020-06-03T14:19:43.728Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MINI_PERSONALPORTAL_TAC",
          "country" : "BR",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "miniapp",
          "language" : "en",
          "consentDate" : "2021-06-03T13:49:05.257Z",
          "legalEntityId" : "BMW_DO_BRASIL_LTDA_",
          "expirationDate" : "3020-06-03T13:49:05.257Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "CH",
          "majorVersion" : 1,
          "minorVersion" : 3,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "fr",
          "brand" : "BMW",
          "consentDate" : "2022-08-01T17:32:43.064Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-01T17:32:43.064Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:44.497Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:44.497Z",
          "consentGroupId" : "5bdb8777-8f7f-4b10-9d2b-49a7b23103ec"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "ALPHABET_FUHRPARKMANAGEMENT_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "CH",
          "majorVersion" : 25,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "taf",
          "language" : "fr",
          "consentDate" : "2022-08-02T09:45:33.128Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3021-08-02T09:45:33.128Z",
          "consentGroupId" : "9809d552-37b0-4a3e-be59-3c4077b6a1d7"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MINI_PERSONALPORTAL_TAC",
          "country" : "CH",
          "majorVersion" : 2,
          "minorVersion" : 1,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "BMW_Charging",
          "language" : "it",
          "consentDate" : "2021-12-09T13:25:11.654Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3020-12-09T13:25:11.654Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "CH",
          "majorVersion" : 7,
          "minorVersion" : 4,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2021-06-16T07:34:17.474Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3020-06-16T07:34:17.474Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "CH",
          "majorVersion" : 7,
          "minorVersion" : 4,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2021-06-16T07:34:17.474Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3020-06-16T07:34:17.474Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "CH",
          "majorVersion" : 7,
          "minorVersion" : 4,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2021-06-16T07:34:17.474Z",
          "legalEntityId" : "BMW_FINANZDIENSTLEISTUNGEN_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3020-06-16T07:34:17.474Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "CH",
          "majorVersion" : 7,
          "minorVersion" : 4,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2021-06-16T07:34:17.474Z",
          "legalEntityId" : "BMW_SCHWEIZ_AG_DIELSDORF",
          "expirationDate" : "3020-06-16T07:34:17.474Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "CZ",
          "majorVersion" : 2,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "cs",
          "brand" : "BMW",
          "consentDate" : "2022-03-15T09:56:11.194Z",
          "legalEntityId" : "BMW_CZECH_REPUBLIC_S_R_O_",
          "expirationDate" : "3021-03-15T09:56:11.194Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "DE",
          "majorVersion" : 6,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-12T14:20:23.321Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-12T14:20:23.321Z",
          "consentGroupId" : "34f4a3d6-a49e-4edd-b833-1b23be4c6323"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T16:02:19.163Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T16:02:19.163Z",
          "consentGroupId" : "8e3aba8b-d534-411e-b977-ed3cd0d847fa"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "DATA_PROCESSING",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:49.094Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3022-06-08T08:27:49.094Z",
          "consentGroupId" : "132fdd6d-8820-4c31-88e4-a1d8a8d4a379"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "GB",
          "majorVersion" : 5,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-06-12T14:42:01.468Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3022-06-12T14:42:01.468Z",
          "consentGroupId" : "4ac5c422-2901-476d-824e-dc531a77a8db"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:19.087Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T08:27:19.087Z",
          "consentGroupId" : "6d8dd038-657d-4701-ba66-3cfd3702e6e5"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:19.087Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3022-06-08T08:27:19.087Z",
          "consentGroupId" : "6d8dd038-657d-4701-ba66-3cfd3702e6e5"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:19.087Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3022-06-08T08:27:19.087Z",
          "consentGroupId" : "6d8dd038-657d-4701-ba66-3cfd3702e6e5"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:19.087Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3022-06-08T08:27:19.087Z",
          "consentGroupId" : "6d8dd038-657d-4701-ba66-3cfd3702e6e5"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:19.087Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3022-06-08T08:27:19.087Z",
          "consentGroupId" : "6d8dd038-657d-4701-ba66-3cfd3702e6e5"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2023-06-08T08:27:19.087Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3022-06-08T08:27:19.087Z",
          "consentGroupId" : "6d8dd038-657d-4701-ba66-3cfd3702e6e5"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "DE",
          "majorVersion" : 12,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwapp",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-08-13T08:47:25.315Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3020-08-13T08:47:25.315Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "DE",
          "majorVersion" : 10,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwapp",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-07-09T13:14:29.380Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3020-07-09T13:14:29.380Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "MyBMWApp",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2022-03-28T10:30:29.787Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-03-28T10:30:29.787Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_POINTS_TAC",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 1,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "MyBMWApp",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2022-03-28T10:30:29.787Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-03-28T10:30:29.787Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_TAGGING_TEST",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2022-03-29T09:13:34.832Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-03-29T09:13:34.832Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:44.546Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:44.546Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "DE",
          "majorVersion" : 32,
          "minorVersion" : 14,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "consentDate" : "2022-02-18T11:49:34.566Z",
          "legalEntityId" : "BMW_M_GMBH_GESELLSCHAFT_F_R_INDIVIDUELLE_AUTOMOBILE_M_NCHEN",
          "expirationDate" : "3021-02-18T11:49:34.566Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MY_BMW_APP_TAC",
          "country" : "DE",
          "majorVersion" : 3,
          "minorVersion" : 1,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "MyBMWApp",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2022-03-28T10:30:29.787Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-03-28T10:30:29.787Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "TOYOTA_SUPRA_CONNECT_PORTAL_TAC",
          "country" : "DE",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "gcdmone",
          "language" : "de",
          "brand" : "BMW",
          "consentDate" : "2021-05-27T16:03:31.638Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3020-05-27T16:03:31.638Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "ES",
          "majorVersion" : 2,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "incar_vehicle",
          "language" : "es",
          "brand" : "BMW",
          "consentDate" : "2022-08-17T15:58:07.247Z",
          "legalEntityId" : "BMW_IBERICA_S_A_MADRID",
          "expirationDate" : "3021-08-17T15:58:07.247Z",
          "consentGroupId" : "0e845132-8b8f-4d3d-8c4f-c695a18198e5"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MINI_ID_TAC",
          "country" : "ES",
          "majorVersion" : 2,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "miniwebcom",
          "language" : "es",
          "consentDate" : "2021-10-14T15:46:53.598Z",
          "legalEntityId" : "BMW_IBERICA_S_A_MADRID",
          "expirationDate" : "3020-10-14T15:46:53.598Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "GB",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "incar_vehicle",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-11-15T09:26:04.684Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3020-11-15T09:26:04.684Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "GB",
          "majorVersion" : 2,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwapp",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-05-27T09:50:41.706Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3020-05-27T09:50:41.706Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_TAGGING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-03-17T12:46:24.484Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-03-17T12:46:24.484Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-03-11T16:35:49.918Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-03-11T16:35:49.918Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-03-11T16:35:49.918Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-03-11T16:35:49.918Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-03-11T16:35:49.918Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-03-11T16:35:49.918Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-03-11T16:35:49.918Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-03-11T16:35:49.918Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CUSTOMER_INFORMATION",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-03-11T16:35:49.918Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-03-11T16:35:49.918Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "GCDM_ONE_REGISTRATION_TAC_PDF",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "touchpoint_id_test_all_profile_sections",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-03-11T16:35:49.918Z",
          "legalEntityId" : "BMW_AG",
          "expirationDate" : "3021-03-11T16:35:49.918Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "SMS",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "SMS",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-07-26T10:25:05.382Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T10:25:05.382Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "SMS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "SMS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "PHONE",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "GB",
          "majorVersion" : 103,
          "minorVersion" : 1,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-04-22T14:43:46.361Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-04-22T14:43:46.361Z",
          "consentGroupId" : "0d7a0e42-84db-4a05-8305-51bf8a134cb9"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:09:15.823Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:09:15.823Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "MARKETING_TEST",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-07-26T13:08:56.849Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-07-26T13:08:56.849Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MINI_PERSONALPORTAL_TAC",
          "country" : "GB",
          "majorVersion" : 2,
          "minorVersion" : 3,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "miniapp",
          "language" : "en",
          "consentDate" : "2021-08-06T08:15:58.643Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3020-08-06T08:15:58.643Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 8,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwsf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-05-31T09:32:15.153Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-05-31T09:32:15.153Z",
          "consentGroupId" : "3cb9bac0-d4df-477c-bbfc-901129a4377c"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 8,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwsf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-05-31T09:32:15.153Z",
          "legalEntityId" : "BMW_FINANCIAL_SERVICES_GB_LTD_FARNBOROUGH",
          "expirationDate" : "3021-05-31T09:32:15.153Z",
          "consentGroupId" : "3cb9bac0-d4df-477c-bbfc-901129a4377c"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "TOYOTA_SUPRA_CONNECT_PORTAL_TAC",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 2,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "toyotawebcom",
          "language" : "en",
          "consentDate" : "2021-11-12T13:08:21.420Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3020-11-12T13:08:21.420Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "TOYOTA_SUPRA_CONNECT_PORTAL_TAC",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 2,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2021-05-27T15:48:02.012Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3020-05-27T15:48:02.012Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "TOYOTA_SUPRA_CONNECT_TAC",
          "country" : "GB",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "gcdmone",
          "language" : "en",
          "consentDate" : "2022-08-17T12:14:36.471Z",
          "legalEntityId" : "BMW_UK_LTD_FARNBOROUGH",
          "expirationDate" : "3021-08-17T12:14:36.471Z",
          "consentGroupId" : "d96d5d73-b159-4ed5-90dd-82392df12722"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "IT",
          "majorVersion" : 1,
          "minorVersion" : 3,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwapp",
          "language" : "it",
          "brand" : "BMW",
          "consentDate" : "2021-06-03T14:04:52.192Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3020-06-03T14:04:52.192Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "ALPHABET_ITALIA_FLEET_MANAGEMENT_S_P_A_ROM",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_RETAIL_S_R_L_",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_RETAIL_S_R_L_",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "ALPHABET_ITALIA_FLEET_MANAGEMENT_S_P_A_ROM",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_RETAIL_S_R_L_",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "ALPHABET_ITALIA_FLEET_MANAGEMENT_S_P_A_ROM",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "ALPHABET_ITALIA_FLEET_MANAGEMENT_S_P_A_ROM",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "ALPHABET_ITALIA_FLEET_MANAGEMENT_S_P_A_ROM",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_RETAIL_S_R_L_",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_RETAIL_S_R_L_",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "IT",
          "majorVersion" : 16,
          "minorVersion" : 9,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "it",
          "consentDate" : "2022-04-20T15:36:31.211Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3021-04-20T15:36:31.211Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MINI_PERSONALPORTAL_TAC",
          "country" : "IT",
          "majorVersion" : 1,
          "minorVersion" : 4,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "miniapp",
          "language" : "it",
          "consentDate" : "2021-06-03T13:51:02.112Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3020-06-03T13:51:02.112Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "TOYOTA_SUPRA_CONNECT_TAC",
          "country" : "IT",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "gcdmone",
          "language" : "it",
          "consentDate" : "2022-03-11T11:52:14.955Z",
          "legalEntityId" : "BMW_ITALIA_S_P_A",
          "expirationDate" : "3021-03-11T11:52:14.955Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "JP",
          "majorVersion" : 2,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "ja",
          "brand" : "BMW",
          "consentDate" : "2021-10-18T10:40:13.835Z",
          "legalEntityId" : "BMW_JAPAN_CORP_",
          "expirationDate" : "3020-10-18T10:40:13.835Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MINI_PERSONALPORTAL_TAC",
          "country" : "JP",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "miniwebcom",
          "language" : "ja",
          "consentDate" : "2021-11-12T11:03:07.397Z",
          "legalEntityId" : "BMW_JAPAN_CORP_",
          "expirationDate" : "3020-11-12T11:03:07.397Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "TOYOTA_SUPRA_CONNECT_PORTAL_TAC",
          "country" : "JP",
          "majorVersion" : 1,
          "minorVersion" : 2,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "toyotawebcom",
          "language" : "ja",
          "brand" : "BMW",
          "consentDate" : "2021-10-11T15:11:42.831Z",
          "legalEntityId" : "BMW_JAPAN_CORP_",
          "expirationDate" : "3020-10-11T15:11:42.831Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_DPP",
          "country" : "KR",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PRIVACY",
          "touchpointId" : "bmwwebcom",
          "language" : "ko",
          "brand" : "BMW",
          "consentDate" : "2022-04-14T08:59:29.546Z",
          "legalEntityId" : "BMW_KOREA_CO_LTD_",
          "expirationDate" : "3021-04-14T08:59:29.546Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_PLD",
          "country" : "KR",
          "majorVersion" : 4,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "DATA_PRIVACY",
          "touchpointId" : "bmwwebcom",
          "language" : "ko",
          "brand" : "BMW",
          "consentDate" : "2022-04-14T08:59:29.525Z",
          "legalEntityId" : "BMW_KOREA_CO_LTD_",
          "expirationDate" : "3021-04-14T08:59:29.525Z"
        }, {
          "consent" :  "ACCEPT",
          "consentDate" : "2023-05-10T11:09:18.826Z",
          "consentGroupId" : "df7b214a-4227-4cc3-8612-1daf1bf5c1b8",
          "country" : "TW",
          "expirationDate" : "3022-05-10T11:09:18.826Z",
          "language" : "zh",
          "legalEntityId" : "PAN_GERMAN_MOTORS_LTD_",
          "majorVersion" : 4,
          "minorVersion" : 0,
          "policyId" : "MINI_CONNECTED_TAC",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "incar_vehicle",
          "usageId" : "CONNECTED_DRIVE"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "KR",
          "majorVersion" : 2,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "bmwwebcom",
          "language" : "ko",
          "brand" : "BMW",
          "consentDate" : "2022-04-14T08:59:29.484Z",
          "legalEntityId" : "BMW_KOREA_CO_LTD_",
          "expirationDate" : "3021-04-14T08:59:29.484Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "LU",
          "majorVersion" : 1,
          "minorVersion" : 2,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-08-02T14:49:07.445Z",
          "legalEntityId" : "BMW_BELGIUM_LUXEMBOURG_NV_SA_BORNEM",
          "expirationDate" : "3020-08-02T14:49:07.445Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MINI_PERSONALPORTAL_TAC",
          "country" : "LU",
          "majorVersion" : 2,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "digitalcharging_mini",
          "language" : "fr",
          "consentDate" : "2021-06-04T11:09:53.175Z",
          "legalEntityId" : "BMW_BELGIUM_LUXEMBOURG_N_V_S_A_BORNEM",
          "expirationDate" : "3020-06-04T11:09:53.175Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "NL",
          "majorVersion" : 2,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "nl",
          "brand" : "BMW",
          "consentDate" : "2021-08-18T14:42:13.294Z",
          "legalEntityId" : "BMW_NEDERLAND_B_V_RIJSWIJK",
          "expirationDate" : "3020-08-18T14:42:13.294Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "NZ",
          "majorVersion" : 1,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "dealercockpit",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-08-23T15:03:02.578Z",
          "legalEntityId" : "BMW_GROUP_NEW_ZEALAND_LTD",
          "expirationDate" : "3020-08-23T15:03:02.578Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_PRIVACY_POLICY_DPP",
          "country" : "NZ",
          "majorVersion" : 1,
          "minorVersion" : 1,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PRIVACY",
          "touchpointId" : "dealercockpit",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-08-23T15:03:02.620Z",
          "legalEntityId" : "BMW_GROUP_NEW_ZEALAND_LTD",
          "expirationDate" : "3020-08-23T15:03:02.620Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "PT",
          "majorVersion" : 4,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "bmwwebcom",
          "language" : "pt",
          "brand" : "BMW",
          "consentDate" : "2021-06-03T13:31:57.998Z",
          "legalEntityId" : "BMW_PORTUGAL_LDA_PORTO_SALVO",
          "expirationDate" : "3020-06-03T13:31:57.998Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "PT",
          "majorVersion" : 19,
          "minorVersion" : 4,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "WHCRM",
          "language" : "pt",
          "consentDate" : "2022-01-17T19:28:27.453Z",
          "legalEntityId" : "BMW_PORTUGAL_LDA_PORTO_SALVO"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "PT",
          "majorVersion" : 19,
          "minorVersion" : 4,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "WHCRM",
          "language" : "pt",
          "consentDate" : "2022-01-15T14:48:16.832Z",
          "legalEntityId" : "BMW_PORTUGAL_LDA_PORTO_SALVO",
          "expirationDate" : "3021-01-15T14:48:16.832Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "RO",
          "majorVersion" : 2,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "bmwwebcom",
          "language" : "ro",
          "brand" : "BMW",
          "consentDate" : "2021-06-03T13:23:58.832Z",
          "legalEntityId" : "BMW_AUSTRIA_GES_M_B_H_SALZBURG",
          "expirationDate" : "3020-06-03T13:23:58.832Z"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_BANK_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_BANK_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_VERTRIEBS_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_GES_M_B_H_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_BANK_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_VERTRIEBS_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_LEASING_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_LEASING_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_VERTRIEBS_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_GES_M_B_H_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_GES_M_B_H_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_LEASING_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_VERTRIEBS_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_LEASING_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_LEASING_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_BANK_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_VERTRIEBS_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "PHONE_MESSENGER_SERVICES",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_BANK_GMBH_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_GES_M_B_H_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "RO",
          "majorVersion" : 15,
          "minorVersion" : 4,
          "usageId" : "ANALYTICS",
          "purposeId" : "MARKETING",
          "touchpointId" : "offerhub",
          "language" : "ro",
          "consentDate" : "2022-06-06T08:27:19.865Z",
          "legalEntityId" : "BMW_AUSTRIA_GES_M_B_H_SALZBURG",
          "expirationDate" : "3021-06-06T08:27:19.865Z",
          "consentGroupId" : "49000d62-33a5-44ef-aebf-1be5cca2f992"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "RU",
          "majorVersion" : 2,
          "minorVersion" : 1,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "ru",
          "brand" : "BMW",
          "consentDate" : "2021-08-02T12:43:00.501Z",
          "legalEntityId" : "BMW_RUSSLAND_TRADING_OOO",
          "expirationDate" : "3020-08-02T12:43:00.501Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "TH",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-06-03T10:38:42.217Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:38:42.217Z",
          "consentGroupId" : "a64c88ca-829f-47b7-a8a2-119191abadd3"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_PRIVACY_POLICY_DPP",
          "country" : "TH",
          "majorVersion" : 1,
          "minorVersion" : 8,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PRIVACY",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:38:42.209Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:38:42.209Z",
          "consentGroupId" : "de8cc7c8-e256-4ecb-8251-cf7c8232858b"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_PRIVACY_POLICY_DPP",
          "country" : "TH",
          "majorVersion" : 1,
          "minorVersion" : 8,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "DATA_PRIVACY",
          "touchpointId" : "Digital",
          "consentDate" : "2022-06-03T03:38:42.000Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T03:38:42.000Z",
          "consentGroupId" : "e4dacaa0-2f19-4511-aba5-7a77d059731d"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "SOCIAL_3RD_PARTIES",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:07.185Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:07.185Z",
          "consentGroupId" : "452c0381-e27d-4b10-a8ed-2b53aa315e93"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:07.185Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:07.185Z",
          "consentGroupId" : "452c0381-e27d-4b10-a8ed-2b53aa315e93"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "PHONE",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:07.185Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:07.185Z",
          "consentGroupId" : "452c0381-e27d-4b10-a8ed-2b53aa315e93"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "SMS",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:07.185Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:07.185Z",
          "consentGroupId" : "452c0381-e27d-4b10-a8ed-2b53aa315e93"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:07.185Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:07.185Z",
          "consentGroupId" : "452c0381-e27d-4b10-a8ed-2b53aa315e93"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:07.185Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:07.185Z",
          "consentGroupId" : "452c0381-e27d-4b10-a8ed-2b53aa315e93"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "SOCIAL_3RD_PARTIES",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:02.317Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:02.317Z",
          "consentGroupId" : "1bf7e334-3bd7-48ff-82c6-f1ff6a4f3e9d"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "PHONE",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:02.317Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:02.317Z",
          "consentGroupId" : "1bf7e334-3bd7-48ff-82c6-f1ff6a4f3e9d"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "MAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:02.317Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:02.318Z",
          "consentGroupId" : "1bf7e334-3bd7-48ff-82c6-f1ff6a4f3e9d"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "SMS",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:02.317Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:02.317Z",
          "consentGroupId" : "1bf7e334-3bd7-48ff-82c6-f1ff6a4f3e9d"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "IN_CAR",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:02.317Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:02.318Z",
          "consentGroupId" : "1bf7e334-3bd7-48ff-82c6-f1ff6a4f3e9d"
        }, {
          "consent" : "REJECT",
          "policyId" : "Marketing",
          "country" : "TH",
          "majorVersion" : 4,
          "minorVersion" : 3,
          "usageId" : "EMAIL",
          "purposeId" : "MARKETING",
          "touchpointId" : "bmwwebcom",
          "language" : "en",
          "consentDate" : "2022-06-03T10:39:02.317Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-06-03T10:39:02.318Z",
          "consentGroupId" : "1bf7e334-3bd7-48ff-82c6-f1ff6a4f3e9d"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "TH",
          "majorVersion" : 1,
          "minorVersion" : 3,
          "usageId" : "FULFILLMENT",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwsf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-05-31T09:32:50.605Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-05-31T09:32:50.605Z",
          "consentGroupId" : "89199339-b09c-41b9-b0ec-327c8a568cce"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "MYBMWSF_TAC_BMW",
          "country" : "TH",
          "majorVersion" : 1,
          "minorVersion" : 3,
          "usageId" : "DATAPROCESSING",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "mybmwsf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2022-05-31T09:32:50.605Z",
          "legalEntityId" : "BMW_THAILAND_CO_LTD_",
          "expirationDate" : "3021-05-31T09:32:50.605Z",
          "consentGroupId" : "89199339-b09c-41b9-b0ec-327c8a568cce"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_PORTAL_TAC",
          "country" : "TW",
          "majorVersion" : 4,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "taf",
          "language" : "en",
          "brand" : "BMW",
          "consentDate" : "2021-07-30T15:42:06.178Z",
          "legalEntityId" : "PAN_GERMAN_MOTORS_LTD_",
          "expirationDate" : "3020-07-30T15:42:06.178Z"
        }, {
          "consent" : "ACCEPT",
          "policyId" : "BMW_CONNECTED_DRIVE_TAC",
          "country" : "TW",
          "majorVersion" : 3,
          "minorVersion" : 0,
          "usageId" : "CONNECTED_DRIVE",
          "purposeId" : "TERMS_AND_CONDITIONS",
          "touchpointId" : "bmwwebcom",
          "language" : "zh",
          "brand" : "BMW",
          "consentDate" : "2022-06-07T15:16:53.612Z",
          "legalEntityId" : "PAN_GERMAN_MOTORS_LTD_",
          "expirationDate" : "3021-06-07T15:16:53.612Z",
          "consentGroupId" : "9352236f-5918-4af6-9095-54cb3f8b0d38"
        } ],
        "gcid" : "ee65d751-1396-4c4b-94c4-81e901b0be8a",
        "ucid" : "C180534661"
      };
      let user = data;

      user = this.sortPhoneNumbers(user);
      user = this.sortAddresses(user);

      currentStore.dispatch("setupUser", user);
      return Promise.resolve(user);
    }
  },

  changePassword(oldPassword: string, newPassword: string, startuptoken?) {
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "Content-Type": "text/plain",
        "X-c2b-Authorization": oldPassword,
        Authorization: accessToken,
      },
      withCredentials: true,
    };
    const loginUrl = prepareUrl(
      currentStore.getters.configure("api_url_update_user_password")
    );
    return axios
      .put(loginUrl, newPassword, config)
      .then((res) => {
        return res;
      })
      .catch((err) => this.handleErrors(err, loginUrl, 'changePassword', true, startuptoken, oldPassword, newPassword));
  },

  changeId(newId: string, password: string, startuptoken?) {
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "Content-Type": "text/plain",
        Authorization: accessToken,
      },
      withCredentials: true,
    };

    config.headers["X-c2b-Authorization"] = password;
    

    const url = prepareUrl(
      currentStore.getters.configure("api_url_update_user_id")
    );
    return axios
      .put(url, newId, config)
      .then((res) => {
        return res;
      })
      .catch((err) => this.handleErrors(err, url, 'changeId', true, startuptoken, newId));
  },

  sortFunction(a,b){
    const aQuality = a.quality;
    const bQuality = b.quality;
    if (aQuality > bQuality) return -1;
    if (aQuality < bQuality) return 1;
    return 0;
  },

  manageTolerantResponse(res, address, params, sectionConfig){
    const suggestedUpdates = {};
    console.log("checkTolerant res: ", res);
    // sort results by quality
    const results = res.data.results.sort((a, b) => this.sortFunction(a,b));
    // get most accurate result
    const mostAccurate = results[0];
    // check the quality value
    if (enums.tolerantConfigs.quality) {
      const isSuggestionAccurate =
        mostAccurate.quality >= enums.tolerantConfigs.quality;
      if (!isSuggestionAccurate) return null;
    }
    // get suggested updates
    let thereIsAnySuggestion = false;
    const responseConfig = enums.tolerantConfigs.response;
    for (const param in responseConfig) {
      const currentValue = address[param] || "";
      let suggestedValue = mostAccurate[responseConfig[param]];

      if(param == "postSingleLine") continue;

      if(
        param == "regionCode" && 
        sectionConfig?.addressesSectionByCountrySelection?.[address["country"]]?.hide_region_code
      ) {
          // console.log("Region code field in tolerant response has been ignored according to the selected country address configurations");
          continue;
      }

      suggestedValue = this.mapTolerantResponseValue('manageTolerant', responseConfig[param], mostAccurate);

      // workaround to ignore "null" - start
      if (suggestedValue && suggestedValue.toLowerCase() == "null") suggestedValue = null;
      // workaround to ignore "null" - end

      //GCDM-268189 OneProfile-Addresses-Defects AU exception to skip tolerant suggestion popup
      if(param === "regionCode" && address.country === "AU") {
        suggestedValue = suggestedValue?.replace(`${address.country} `, "");
      }

      if (
        suggestedValue &&
        currentValue.toLowerCase() !== suggestedValue.toLowerCase()
      ) {
        console.log(`${param}: ${currentValue} !== ${suggestedValue}`);
        thereIsAnySuggestion = true;
      }
      suggestedUpdates[param] = suggestedValue;
    }
    // country workaround - start
    suggestedUpdates["country"] = params.country;
    // country workaround - end
    suggestedUpdates["status"] =
      mostAccurate.ReturnCode !== 0 ? "ERROR" : "SUGGESTED";
    return thereIsAnySuggestion ? suggestedUpdates : null;
  },

  fastComplete(parameters, tolerantProfileKey, univoqueBy){
    console.log(`fastComplete - `, parameters, tolerantProfileKey);
    let tolerantUrl = prepareUrl(currentStore.getters.configure("api_url_tolerant_"+tolerantProfileKey));
    const params = {
      street: "",
      country: "",
      reqId: 1,
      maxResultCount: 5,
      postalcode: "",
      city: "",
      province: "",
      addressline2: "",
      addressline3: "",
      number: "",
      singleline: ""
    };
    // switch request configuration
    const requestConfig = enums.tolerantConfigs[`${tolerantProfileKey}_request`];
    if (!requestConfig) console.log('ERROR - (fastComplete) no configuration found for tolerant profile: ', tolerantProfileKey);

    for (const param in requestConfig) {
      params[requestConfig[param]] = parameters[param] || "";
    }
    const config = {
      params,
    };
    return axios
      .get(tolerantUrl, config)
      .then((res) => {
        let suggestions = res.data.results;

        suggestions = suggestions.filter(suggestion => {
          const minimumQuality = enums.tolerantConfigs.quality;
          return suggestion.quality ? parseInt(suggestion.quality) >= minimumQuality : false;
        })

        if (suggestions && suggestions.length === 0) return [];

        // Remove duplicates from suggestions if univoqueBy array has at least one element specified
        if(univoqueBy?.length) {
          let univoqueSuggestions = [] as any;

          suggestions.forEach(suggestion => {
            if(
              !univoqueSuggestions.length ||
              univoqueSuggestions.find(univoqueSuggestion => {
                let isDuplicate = true;

                univoqueBy.forEach(univoqueByField => {
                  if(univoqueSuggestion[univoqueByField] != suggestion[univoqueByField]) {
                    isDuplicate = false;
                  }
                });

                return !isDuplicate;
              })
            ) {
              univoqueSuggestions.push(suggestion);
            }
          });

          suggestions = univoqueSuggestions;
        }

        const responseConfig = enums.tolerantConfigs.response;

        suggestions = suggestions.map(suggestion => {
          let parsedSuggestion = {};
          for (const key in responseConfig) {
            parsedSuggestion[key] = this.mapTolerantResponseValue('fastComplete', responseConfig[key], suggestion);
            //[GCDM-237877] Show region as regions in addressbook: Harmonize new implementation with Tolerant, exception for JP
            if(key=="regionCode" && parsedSuggestion['country']=='JP'){
              parsedSuggestion[key] = parsedSuggestion[key].replace('JP ','');
            }
          }
          return parsedSuggestion;
        });

        return suggestions;
      })
      .catch((err) => {
        trackingUtils.trackError(tolerantUrl, 'call', err, '', '-1', 'TOLERANT');
        return null;
      });
  },

  
  /**
   * 
   * @param calledBy - specify if the function is called from fastComplete or manageTolerant functions
   * @param tolerantConfProperty - "tolerant" configuration property from the "response" structure in enum.js, can be a string or a complex object 
   * @param tolerantResponse 
   * @param keySeparator the config key separator for chaining property, default = '|'
   * @returns the "tolerant" value corresponding to the "tolerant" property OR the chaining of more "tolerant" properties
   */  
  mapTolerantResponseValue(calledBy: 'fastComplete' | 'manageTolerant', tolerantConfProperty: string | {concatSeparator?: string; fastComplete: string; manageTolerant: string}, tolerantResponse: any, keySeparator: string = '|'): string{ 
    let newKey = typeof tolerantConfProperty != "object" ? tolerantConfProperty : tolerantConfProperty[calledBy];
    let concatSeparator = typeof tolerantConfProperty === "object" && tolerantConfProperty.concatSeparator ? tolerantConfProperty.concatSeparator : " ";
    let parsedKeys = newKey.split(keySeparator).map(val => val.trim());
    let valueToConcat: string = "";
    for(let parsedKey of parsedKeys){
      valueToConcat += tolerantResponse[parsedKey] && !valueToConcat.includes(tolerantResponse[parsedKey]) ? 
      `${ parsedKeys.indexOf(parsedKey) != 0 ? concatSeparator: ''}${tolerantResponse[parsedKey]}`
      : 
      '';
    }
    return valueToConcat.trim();
  },

  suggestAddress(address: any, tolerantProfileKey, sectionConfig) {
    let tolerantUrl = prepareUrl(currentStore.getters.configure("api_url_tolerant_"+tolerantProfileKey));
    const params = {
      reqId: 1,
      maxResultCount: 1,
      organization: "",
      houseNumber: "",
      postalcode: "",
      country: "",
      city: "",
      regioncode: "",
      addressline1: "",
      addressline2: "",
      addressline3: "",
    };

    // switch request configuration
    const requestConfig = enums.tolerantConfigs[`${tolerantProfileKey}_request`];
    if (!requestConfig) console.log('ERROR - (suggestAddress) no configuration found for tolerant profile: ', tolerantProfileKey);

    for (const param in requestConfig) {
      params[requestConfig[param]] = address[param] || "";
    }
    const config = {
      params,
    };

    return axios
      .get(tolerantUrl, config)
      .then((res) => {
        return this.manageTolerantResponse(res, address, params, sectionConfig);
      })
      .catch((err) => {
        trackingUtils.trackError(tolerantUrl, 'call', err, '', '-1', 'TOLERANT');
        return null;
      });

    // if (currentEnv !== "development") {
    // return axios
    //   .get(tolerantUrl, config)
    //   .then((res) => {
    //     return this.manageTolerantResponse(res, address, params);
    //   })
    //   .catch((err) => {
    //     trackingUtils.trackError(tolerantUrl, 'call', err, '', '-1', 'TOLERANT');
    //     return null;
    //   });
    // } else {
    //   const toReturn = {
    //     street: 'Test',
    //     houseNumber: 'Test',
    //     strSuppl1: 'Test',
    //     strSuppl2: 'Test',
    //     postalCode: 'Test',
    //     city: 'Test',
    //     regionCode: 'Test',
    //     country: 'Test'
    //   };
    //   return Promise.resolve(toReturn);
    // }
  },


  getCesimSubscription(startuptoken?) {
    if (currentEnv === "development") {
      return Promise.resolve(
        []
      );
      /* return Promise.resolve(
        [{"subscriptionId":"190498","subscriptionType":"PRIVATE","onboardingStatus":"FINISHED_AC_AVAILABLE","mnoId":"v2cadxz0tb","mnoName":"Reference MNO","mnoType":"PREMIUM","mnoTokenStatus":"AVAILABLE","activationCodeStatus":"NOT_AVAILABLE","phoneNumber":"49189740201431","dateCreated":"2022-10-11T13:54:58.488Z"}]
      ); */
    }
    const url = prepareUrl(currentStore.getters.configure("api_url_cesim_subscription"));
    const cesimApplicationId = currentStore.getters.configure("key_for_cesim_application_id");
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "BMW-request-id": cesimApplicationId,
        Authorization: accessToken,
        clientId: "one-page-" + currentStore.state.configurationParams.brand,
      },
    };
    return axios
      .get(url, config)
      .then((res: any) => {
        return res.data.subscriptions;
      })
      .catch((err) => this.handleErrors(err, url, 'getCesimSubscription', true, startuptoken));
  },

  invalidateCesimSubscription(startuptoken?) {
    const url = prepareUrl(currentStore.getters.configure('api_url_cesim_invalidate'));
    const cesimApplicationId = currentStore.getters.configure("key_for_cesim_application_id");
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "BMW-request-id": cesimApplicationId,
        Authorization: accessToken,
        clientId: "one-page-" + currentStore.state.configurationParams.brand,
      },
    };
    return axios
      .post(url, {}, config)
      .then((res: any) => {
        return res;
      })
      .catch((err) => this.handleErrors(err, url, 'invalidateCesimSubscription', true, startuptoken));
  },

  getCesimCountries(startuptoken?) {
    if (currentEnv === "development") {
      const mock = ["JP", "MQ", "DE"];
      return Promise.resolve(mock);
    }
    const url = prepareUrl(currentStore.getters.configure('api_url_cesim_countries'));
    const cesimApplicationId = currentStore.getters.configure('key_for_cesim_application_id');
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "BMW-request-id": cesimApplicationId,
        Authorization: accessToken,
        clientId: "one-page-" + currentStore.state.configurationParams.brand,
        "clientId-context": currentStore.state.configurationParams.client || 'gcdmone',
      },
    };
    return axios
      .get(url, config)
      .then((res) => {
        return res.data.premiumMnoCountries;
      })
      .catch((err) => this.handleErrors(err, url, 'getCesimCountries', true, startuptoken));
  },

  getCesimMnos(countryId, startuptoken?) {
    if (currentEnv === "development") {
      const mock = [
        { id: "alkaxxwo20", name: "Vodafone DE" },
        { id: "v2cadxz0tb", name: "Reference MNO" },
        { id: "kf8jvsnio0", name: "Telekom DE" },
      ];
      return Promise.resolve(mock);
    }
    let url = prepareUrl(currentStore.getters.configure('api_url_cesim_mnos'));
    url = url.replace('${country_code}', countryId.toLowerCase());
    const cesimApplicationId = currentStore.getters.configure('key_for_cesim_application_id');
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "BMW-request-id": cesimApplicationId,
        Authorization: accessToken,
        clientId: "one-page-" + currentStore.state.configurationParams.brand,
        "clientId-context": currentStore.state.configurationParams.client || 'gcdmone',
      },
    };
    return axios
      .get(url, config)
      .then((res) => {
        return res.data.mnoinfo;
      })
      .catch((err) => this.handleErrors(err, url, 'getCesimMnos', true, startuptoken, countryId));
  },

  getCesimRedirect(mnoId, secretKnowledge, startuptoken?) {

    if (currentEnv === "development") {
      const mock = "https://premium-mno.de/portal/login?id=we3r2ro398dl9399";
      return Promise.resolve(mock);
    }
    let url = prepareUrl(currentStore.getters.configure('api_url_cesim_redirect'));
    url = url.replace('${mno_id}', mnoId);
    const cesimApplicationId = currentStore.getters.configure('key_for_cesim_application_id');
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        "BMW-request-id": cesimApplicationId,
        "Secret-knowledge": secretKnowledge,
        Authorization: accessToken,
        clientId: "one-page-" + currentStore.state.configurationParams.brand,
      },
    };
    return axios
      .get(url, config)
      .then((res) => {
        return res.data.redirectUrl;
      })
      .catch((err) => this.handleErrors(err, url, 'getCesimRedirect', true, startuptoken, mnoId, secretKnowledge));
  },

  getProfilePicture(startuptoken?) {
    if (currentEnv !== "development") {
      let url = prepareUrl(currentStore.getters.configure("api_url_get_profile_picture"));
      const token = startuptoken || window.localStorage.getItem("oneid_access_token");
      const accessToken = `Bearer ${token}`;
      const config = {
        responseType: 'blob',
        headers: {
          Authorization: accessToken,
        },
      };
      if(currentStore.getters.configure('enable_profile_picture_by_brand')){
        const brand = enums.profilePictureBrands[currentStore.state.configurationParams.brand];
        if(url.includes('?')){
          url = url+'&brand='+brand;
        }else{
          url = url+'?brand='+brand;
        }
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      return axios.get(url, config).then(res => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(res.data);
          reader.onload = () => resolve(reader.result);
        });
        }).catch(err => this.handleErrors(err, url, 'getProfilePicture', true, startuptoken));
    }else{
      //UNCOMMENT TO MOCK
      return Promise.resolve( "data:image/gif;base64,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");
      // return Promise.resolve( "");
    }
  },

  uploadPicture(img, startuptoken?){
    let url = prepareUrl(currentStore.getters.configure("api_url_profile_set_profile_picture"));
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const formData = new FormData();
    formData.append("profilePictureFile", img, 'profile-picture.jpg');
    const config = {
      headers: {
        Authorization: accessToken,
        "Content-Type": "multipart/form-data",
      },
    };
    if(currentStore.getters.configure('enable_profile_picture_by_brand')){
      const brand = enums.profilePictureBrands[currentStore.state.configurationParams.brand];
      if(url.includes('?')){
        url = url+'&brand='+brand;
      }else{
        url = url+'?brand='+brand;
      }
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.put(url, formData, config).then(res => {
      return res;
    }).catch(err => this.handleErrors(err, url, 'uploadPicture', true, startuptoken, img));
  },

  geocode(lat, lon){
    const url = prepareUrl(currentStore.getters.configure("api_url_geocoding")).replace("${lat}", lat).replace("${lon}", lon);
    const config = {
      headers: {
        'x-api-key': currentStore.getters.configure('key_for_geocoding_api'),
      },
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.get(url, config).then(res => {
      return res;
    }).catch(err => {
      trackingUtils.trackError(url, 'call', err, '', '-1', 'geocode');
    });
  },

  removePicture(startuptoken?){



    let url = prepareUrl(currentStore.getters.configure("api_url_remove_profile_picture"));
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        Authorization: accessToken,
      },
    };
    if(currentStore.getters.configure('enable_profile_picture_by_brand')){
        const brand = enums.profilePictureBrands[currentStore.state.configurationParams.brand];
      if(url.includes('?')){
        url = url+'&brand='+brand;
      }else{
        url = url+'?brand='+brand;
      }
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.delete(url, config).then(res => {
      return res;
    }).catch(err => this.handleErrors(err, url, 'removePicture', true, startuptoken));




  },

  getEmailByPreRegToken(token){
    const url = prepareUrl(currentStore.getters.configure("api_url_get_email_by_token"));
    let config;
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.get(url+"/"+token, config).then(res => {
      return res;
    }).catch(err=> this.handleErrors(err, url, 'getEmailByPreRegToken', false, false));
  },

  authenticateCode(code, GCDMSSO){
    const url = prepareUrl(currentStore.getters.configure("api_url_authenticate_device_code"));
    let config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    };
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config.headers["X-c2b-Api-Key"]= clientId
    }

    const body={
      user_code: code,
      csrf:GCDMSSO,
      scope:'authenticate_user',
      decision:'allow'
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.post(url, qs.stringify(body), config).then(res => {
      return res;
    }).catch(err => this.handleErrors(err, url, 'authenticateCode', false, false));
  },

  getSalutations(){
    const url = prepareUrl(currentStore.getters.configure("api_url_get_salutations"));
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.get(url, config).then(res => {
      return res;
    }).catch(err => this.handleErrors(err, url, 'getSalutations', false, false));
  },

  getGenders() {
    const url = prepareUrl(currentStore.getters.configure("api_url_get_genders"));
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.get(url, config).then(res => {
      return res;
    }).catch(err => this.handleErrors(err, url, 'getGenders', false, false));
  },

  getNationalities() {
    const url = prepareUrl(currentStore.getters.configure("api_url_get_nationalities"));
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.get(url, config).then(res => {
      return res;
    }).catch(err => this.handleErrors(err, url, 'getNationalities', false, false));
  },

  getRegionCodes(country: string){
      //[GCDM-237883] Show region as regions in addressbook: Implementation 
  if(regionCodes[country]?.data?.valuelists && regionCodes[country]?.data?.valuelists[`address.countryRegion.${country}`]) {
    return new Promise((resolve) => {return resolve(regionCodes[country])});
  }

    let url = prepareUrl(currentStore.getters.configure("api_url_get_region_codes"));
    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }
    url = url.replace('${country}', country)
    if (country !== currentStore.state.configurationParams.country) {
      url = url.concat("&locales=en");
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return axios.get(url, config).then(res => {
      //[GCDM-237883] Show region as regions in addressbook: Implementation 
      regionCodes[country] = res;
      return res;
    }).catch(err => this.handleErrors(err, url, 'getRegionCodes', false, false));
  },

  getDealers(country, brand) {
    let url = prepareUrl(currentStore.getters.configure("api_url_get_dealers")).replace("${country}", country);

    if(brand == "mini") {
      url += "&category=MINI"
    }

    return axios.get(url)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'getDealers', false, false)
      );
  },

  passkeyLoginStart(body=null) {
    const url = prepareUrl(currentStore.getters.configure("api_url_passkey_login_start"));

    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }

    return axios.post(url, body, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'passkeyLoginStart', false, false)
      );
  },

  passkeyLoginComplete(body=null): Promise<any> {
    const url = prepareUrl(currentStore.getters.configure("api_url_passkey_login_complete"));

    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }
    
    return axios.post(url, body, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'passkeyLoginComplete', false, false)
      );
  },

  passkeyRegisterStart(body=null) {
    const url = prepareUrl(currentStore.getters.configure("api_url_passkey_register_start"));

    let config;

    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config = {
        headers: {
          "X-c2b-Api-Key": clientId
        }
      };
    }

    return axios.post(url, body, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'passkeyRegisterStart', false, false)
      );
  },
  
  getQRCode(startuptoken?) {
    const url = prepareUrl(currentStore.getters.configure("api_url_get_qr_code"));

    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        Authorization: accessToken,
      },
    };

    return axios.get(url, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'getQRCode', true, startuptoken)
      );
  },

  passkeyRegisterComplete(body=null, deviceName=null) {
    const url = prepareUrl(currentStore.getters.configure("api_url_passkey_register_complete"));
    let config = {
      headers: {}
    };
    const clientId = currentStore.getters.getConfigurations.client?.client?.client_id;

    if(clientId) {
      config.headers["X-c2b-Api-Key"] = clientId;
    }
    if(deviceName) {
      config.headers["deviceName"] = deviceName;
    }

    return axios.post(url, body, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'passkeyRegisterComplete', false, false)
      );
  },

  getPasskeys(startuptoken?) {
    const url = prepareUrl(currentStore.getters.configure("api_url_passkeys_get"));
    const originalUserData = currentStore.getters.getOriginalUser;

    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
  
    const config = {
      headers: {
        loginId: originalUserData.gcid,
        Authorization: accessToken
      },
    };

    if (currentEnv == "development" ) {
      return new Promise((resolve) => resolve({data: { 
        "resultCount": 4,
        "result": [
          {
              "_id": "c2137d1e-f55a-4fc5-bb63-f6b321025140",
              "_rev": "1151779561",
              "deviceName": "Chrome on Mac__1704805633320",
              "uuid": "c2137d1e-f55a-4fc5-bb63-f6b321025140",
              "deviceManagementStatus": true
          },
          {
              "_id": "f868e1cd-2738-4fda-8479-833c71e1e5fa",
              "_rev": "288354404",
              "deviceName": "Chrome on Mac__1701341869466",
              "uuid": "f868e1cd-2738-4fda-8479-833c71e1e5fa",
              "deviceManagementStatus": true
          },
          {
              "_id": "242b2bfa-c573-4c49-a4e4-7307507165f6",
              "_rev": "1047619783",
              "deviceName": "YubiKey 5 Series with NFC__1701334664211",
              "uuid": "242b2bfa-c573-4c49-a4e4-7307507165f6",
              "deviceManagementStatus": true
          },
          {
              "_id": "08e6df2c-8650-4c71-8a0e-0b2ba5c3620e",
              "_rev": "82972768",
              "deviceName": "Chrome on Mac__1701334562966",
              "uuid": "08e6df2c-8650-4c71-8a0e-0b2ba5c3620e",
              "deviceManagementStatus": true
          }
      ]
      }}))
    }

    return axios.get(url, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'getPasskeys', true, false)
      );
  },

  deletePasskey(passkeyId, startuptoken?) {
    const url = prepareUrl(currentStore.getters.configure("api_url_passkey_delete").replace("${passkeyId}", passkeyId));
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        Authorization: accessToken,
      },
    };

    return axios.delete(url, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'deletePasskey', true, startuptoken)
      );
  },

  renamePasskey(passkeyId, passkeyName, startuptoken? ) {
    const url = prepareUrl(currentStore.getters.configure("api_url_passkey_rename").replace("${passkeyId}", passkeyId));
    const token = startuptoken || window.localStorage.getItem("oneid_access_token");
    const accessToken = `Bearer ${token}`;
    const config = {
      headers: {
        Authorization: accessToken,
        deviceName: passkeyName
      },
    };

    return axios.post(url, {}, config)
      .then(res => {
        return res;
      })
      .catch(err =>
        this.handleErrors(err, url, 'renamePasskey', true, startuptoken)
      );
  },

  handleErrors(err, url, lastCall, isProtected, fromWC, ...args){
    let toReturn = {};
    let finalError = {
      message:"",
      cause:"",
      code:"",
      errorCode: enums.errorReasons.NETWORK
    }
    console.log('err.response: ',err.response);
    if(err && err.response){
      finalError.code = err.response.status;

      if(finalError.code==enums.errorReasons.UNAUTHORIZED && isProtected && (!err.response.data || !err.response.data.errorCode || err.response.data.errorCode!= enums.errorReasons.WRONG_PASSWORD)){

        finalError = this.prepareUnauthorizedError(finalError, err);

        toReturn = this.prepareErrorPromise(lastCall, fromWC, ...args);

        trackingUtils.trackError(url, 'call', finalError.message, finalError.cause, finalError.code, lastCall);
        return toReturn;
      }else{
        finalError.errorCode = finalError.code;
        finalError = this.prepareErrorFromResponse(finalError, err)
        const errorPayload = trackingUtils.trackError(url, 'call', finalError.message, finalError.cause, finalError.code, lastCall);
        toReturn = Promise.reject({errorCode:finalError.errorCode, errorPayload, headers: err.response.headers});
        return toReturn;
      }
    }else{
      finalError.code = finalError.errorCode;
      finalError = this.prepareDefaultError(finalError, err);
      const errorPayload = trackingUtils.trackError(url, 'call', finalError.message, finalError.cause, finalError.code, lastCall);
      toReturn = Promise.reject({errorCode:finalError.errorCode, errorPayload});
      return toReturn;
    }

  },

  prepareUnauthorizedError(finalError, err){
    if(err.response.data){
      finalError.message = err.response.data.error_description || finalError.message;
      finalError.cause = err.response.data.error || finalError.cause;
    }
    return finalError;
  },
  prepareErrorFromResponse(finalError, err){
    if(err.response.data){
     finalError = this.getErrorsFromResponseData(finalError, err);
    }
    if (
      err.response.data.reasons &&
      err.response.data.reasons[0] &&
      err.response.data.reasons[0].constraint
    ) {
      finalError.errorCode = err.response.data.reasons[0].constraint;
    }
    if (
      err.response.data.reasons &&
      err.response.data.reasons[0] &&
      err.response.data.reasons[0].id
    ) {
      finalError.errorCode = err.response.data.reasons[0].id;
    }
    return finalError;
  },
  getErrorsFromResponseData(finalError, err){
    if(err.response.data.error_description) finalError.message = err.response.data.error_description;
    if(err.response.data.error) finalError.cause = err.response.data.error;
    if(err.response.data.message) finalError.message = err.response.data.message;
    if(err.response.data.errorCode) finalError.cause = err.response.data.errorCode;
    if(err.response.data.errorCode) finalError.cause = err.response.data.errorCode;
    if(err.response.data.internalErrorCode) finalError.cause = err.response.data.internalErrorCode
    if(err.response.data.errorCode) finalError.errorCode = err.response.data.errorCode
    if(err.response.data.errorCode) finalError.errorCode = err.response.data.errorCode

    return finalError;
  },
  prepareDefaultError(finalError, err){
    if(err.message) finalError.message = err.message;
    if(err.name) finalError.cause = err.name;
    return finalError;
  },
  prepareErrorPromise(lastCall, fromWC, ...args){
    if(fromWC){
      //webcomponent case
      return this.errorOrRefreshSessionWithJSEvents(lastCall, ...args);
    }else{
      return this.errorOrRefreshSessionWithRefreshToken(lastCall, ...args);
    }
  },

  errorOrRefreshSessionWithJSEvents(lastCall, ...args){
    utils.showGlobalLoader();
    const promise = new Promise(function(resolve, reject) {
      window.addEventListener("WEB_COMPONENT_ACCESS_TOKEN", function(e: any) {
        console.log('[One Profile Log] token refreshed:',e.detail.oneid_access_token);
        window.removeEventListener("WEB_COMPONENT_ACCESS_TOKEN",()=>{console.log('access token refreshed')});
        return resolve(e);
      });

    });
    const event = new CustomEvent("WEB_COMPONENT_SESSION_EXPIRED");
    window.dispatchEvent(event);
    console.log('[One Profile Log] event dispatched:','WEB_COMPONENT_SESSION_EXPIRED');
    return promise.then(
      (e: any)=>{
        return this[lastCall](...args, e.detail.oneid_access_token);
      }
    );
  },

  errorOrRefreshSessionWithRefreshToken(lastCall, ...args){
    utils.showGlobalLoader();
    const refreshToken = this.refreshToken.bind(this);
    const promise = new Promise(function(resolve, reject) {
      refreshToken(window.localStorage.getItem("oneid_refresh_token"), currentStore.getters.configure("key_for_internal_client_id"),window.localStorage.getItem("oneid_code_verifier"))
        .then((res) => {
          utils.hideGlobalLoader();
          if(res.data){
            window.localStorage.setItem("oneid_access_token",res.data.access_token);
            window.localStorage.setItem("oneid_refresh_token",res.data.refresh_token);
            return resolve(res);
          }else{
            return reject();
          }
        })
        .catch((err) => {
          utils.hideGlobalLoader();
          utils.showMessage("WARNING", currentStore.getters.translate("profile_expired_access_token_error"));
          setTimeout(() => {
            sessionUtils.cleanLocalStorage();
            let currentParams = utils.getQueryParams();
            delete currentParams.register_first;
            // check if redirectFrom parameter is already defined
            const redirectFrom = currentRouter.currentRoute.value.name==='link' ? 'link' : 'profile';
            if(currentRouter){
              currentRouter.push({
                path: 'login',
                query: { ...currentParams, redirectFrom },
              });
            }
          }, properties.TIMEOUT_LOGOUT);
          return reject();
        });

    });
    return promise.then(
      (e: any)=>{
        return this[lastCall](...args);
      }
    );
  },

  sortPhoneNumbers(user) {
    // console.log("communicationPhones (start): ", JSON.parse(JSON.stringify(user.businessPartner?.communications?.communicationPhones)));

    if(user.businessPartner?.communications?.communicationPhones?.length) {
      user.businessPartner.communications.communicationPhones = user.businessPartner.communications.communicationPhones
      .sort((a, b) => this.sortPhoneNumbersUpdatedAt(a, b))
      .sort((a, b) => this.sortPhoneNumbersPreferred(a, b))
    }

    // console.log("communicationPhones (end): ", user.businessPartner?.communications?.communicationPhones);

    return user;
  },

  sortPhoneNumbersUpdatedAt(a, b) {
    if(a.updatedAt === undefined && b.updatedAt === undefined) return 0;
    else if(a.updatedAt === undefined && b.updatedAt !== undefined) return 1;
    else if(a.updatedAt !== undefined && b.updatedAt === undefined) return -1;
    else return (new Date(b.updatedAt) as any) - (new Date(a.updatedAt) as any);
  },

  sortPhoneNumbersPreferred(a, b) {
    if(a.preferred == b.preferred) return 0;
    else if(a.preferred && !b.preferred) return -1;
    else if(!a.preferred && b.preferred) return 1;
    else return 0;
  },

  sortAddresses(user) {
    // console.log("addresses (start): ", JSON.parse(JSON.stringify(user.businessPartner?.addresses?.addresses)));

    if(user.businessPartner?.addresses?.addresses?.length) {
      user.businessPartner.addresses.addresses = user.businessPartner.addresses.addresses
      .sort((a, b) => this.sortAddressesUpdatedAt(a, b))
      .sort((a, b) => this.sortAddressesPreferredFor(a, b));
    }

    // console.log("addresses (end): ", user.businessPartner?.addresses?.addresses);

    return user;
  },

  sortAddressesUpdatedAt(a, b) {
    if(a.updatedAt === undefined && b.updatedAt === undefined) return 0;
    else if(a.updatedAt === undefined && b.updatedAt !== undefined) return 1;
    else if(a.updatedAt !== undefined && b.updatedAt === undefined) return -1;
    else return (new Date(b.updatedAt) as any) - (new Date(a.updatedAt) as any);
  },

  sortAddressesPreferredFor(a, b) {
    if(a.preferredFor && b.preferredFor) return 0;
    else if(a.preferredFor && !b.preferredFor) return -1;
    else if(!a.preferredFor && b.preferredFor) return 1;
    else if(a.preferred && b.preferred) return 0;
    else if(a.preferred && !b.preferred) return -1;
    else if(!a.preferred && b.preferred) return 1;
    else return 0;
  }

};